import { effect, style, template, delegateEvents, insert, memo, addEventListener, createComponent, className, setAttribute, isServer, render } from 'solid-js/web';
import { onMount, onCleanup, For, createSignal, createEffect } from 'solid-js';
import { StorageKey, ColorMode, NetworkType, ExtensionMessageTarget } from '@mavrykdynamics/beacon-types';
import QRCode from 'qrcode-svg';
import { Logger, Serializer, IndexedDBStorage, SDK_VERSION, windowRef } from '@mavrykdynamics/beacon-core';
import { PostMessageTransport } from '@mavrykdynamics/beacon-transport-postmessage';
import { parseUri } from '@walletconnect/utils';
import { generateGUID } from '@mavrykdynamics/beacon-utils';

const extensionList = [{
  "key": "mavryk_chrome",
  "id": "cgddkajmbckbjbnondgfcbcojjjdnmji",
  "name": "Mavryk Wallet Chrome",
  "shortName": "Mavryk",
  "color": "",
  "logo": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAX/klEQVR4Ae3BD3Cc9Xng8e/z21ewdURREnE11CSeQwkqrGspcQYnxwzi6lDTwCHOMqyNgZdAQhmSO2fAUzKEevcMhdTHhUA5hxLHr8CgNcaNQmACDRlEzgPmImCN144ogjqJkhisMOIQdIlW+5xonVQYSdaf/fPu7vP5CKai+R1aT4SFCAuABUAjMB+YDxwLNAD1QD3QwBiFesDjvXICw0AOGAaywBAwBPwGZUgdB0Q5AAwgDPBbBoIdMoSpWIIJPT+uUaAZiJGjiQhNCCcrNAENlNegwH7gZXL04dGHkOFf6Au6JYcJNcGEih/XKLAEoQVlCfBJhWbAo7LkBPpQnsXRS55e8mSC7TKMCQ3BlJXfoY14nE6eNhynKSwBPKpTTqAXeAboAXqClAxhykYwJeW3q8cf0IayHOEMVVoAjxolQi/KkwKPKuwMUpLFlIxgis7v0EY8zgHaFc4AGjATGRboAXaQ5+HgARnEFJVgisLv0AVABx4rFJYCHmYmcgK7yLFDhAe3bJcBTMEJpmD8uDYA7cCFCssAD1MIOYEe4D6gO0jJEKYgBDNnflzbyHOFOs4D6jHFlBVICdy3JSWPY+ZEMLPix7WBHFeox5VAE6Yc9gvcSZ4geEAGMTMmmBnx4xojz7XquAjwMGGQFUgB3wxSksZMm2CmxY9rG7BeoQ0TWgKPItwVdEk35ogEMym/XT081mgd16DEMBVDII2QDLqkGzMpwbyP364eHmvU43qgCVOxBNIIyaBLujHvI5j38Ds0rh4bgCZM1RBIIySDLunG/J5g/pUf1zaFm4GlmKolkAa+GqTkUQxCjfM7tAmPOxSWY2qGQDeQDFKSpoYJNcqPawOQULga8DC1KCvCt8hxQ7BdhqlBQg3yV+oajbARmI8xcEBgXZCSrdQYoYb4K7WZCJsU2jDm/XpklKuC7dJHjRBqgN+uHlGuU7geiGLM5LIi3ILy9SAlWaqcUOX8ldqiEbYALRgzTQJp4LIgJWmqmFCl/Hb1OJprVdgAeBgzc1kRbkH5epCSLFVIqEL+Km1S5V5gKcbM3S6BVUFK9lNlhCrjx3WNwiagHmMKJyvwhSAlW6kiQpXw4xolz7fUcSnGFInkCXBcFaQkSxUQqoC/SpsUvo/SjDHFpvSJ49ygS/qpcBEqnB/XdoXHgBMwphSERuCLrbHE3nQm2UcFEyqU364ef8DXVFmPMWUicFOQkq9RoYQK5K/Wes3TBZyDMeX3sMDKICVZKkyECuPHdaEqPwJOx5hw+DjKOa2LEo+lM8khKkiECuJ36BJ1PAY0YUyYCPOB9tbmxJPpfckDVIgIFcKP63J1PAI0Ykw4NeDwW2OJZ9OZZD8VIEIF8FdpXKELmIcx4eYBHa2nJF5M703uI+QihJwf12sV7gI8jKkMHsIFrbHEW+lM8ilCLEKI+XFNKNyEMZXprNZYQtKZZA8hFSGk/LgmFNZjTGVra40lJJ1J9hBCEULIj2tCYT3GVIe21lhC0plkDyETIWT8uCYU1mNMdWlrjSUknUn2ECIRQsSPa0JhPcZUp7bWWELSmWQPIREhJPxVeq3CTRhT3dpaT028ld6bfIoQiBAC/mrtUOVujKkFwlmtpyZeTO9NZiizCGXmx3W5KtsAD2NqhXBOayzxbDqT7KeMIpSRv1Jb1PFDIIoxtcUD2lubEz9M70v+ijKJUCZ+XBeq4wdAI8bUpqNw/EVrLPHddCY5RBlEKAM/rlGFHwLNGFPb/lBgWcufJO5N70v+lhJzlIHCdqAFYwwKMY3Q5berR4k5SsxfpTcC52CMGe8conyNEotQQn5c2xXuxBgzkbbWWGJ3OpPso0QcJeKv0iaFLowxk1K411+lTZSIowT8uEYVvg9EMcZMpV7zfN+Pa5QScJRCnm+hNGOMOTKhmTybKIEIRebHdY0KSYwx0ye0tJ6a+Fl6bzJNETmKyI/rQoW7McbMmAp3+Ku0iSJyFIkf16hCFxDFGDMb9arc67erR5E4iuc6YCnGmLlYSpRrKRJHEfhxbVH4K4wxc6awwe/QForAUWB+XKMKW4AoxphC8DTCFr9dPQrMUXjXAS0YYwpHaNEo11FgjgLyV2qzwl9hjCmG6/2V2kwBOQpII2wCohhjiiGqETZRQI4C8VfpGqANY0wxtfkrdQ0F4igAf7XWq7IRY0zRaYSNflwbKABHAWieG4H5GGNKYb4qCQrAMUf+Ko0BV2KMKR3har9Dm5gjx1wpG4AoxphS8tTjDubIMQd+XJcrtGOMKYflflzbmAPHHCjcjDGmbBRuZg4cs+THtR1owRhTTkv9lbqGWXLMksJ6jDFlpxHW++3qMQuOWfDj2g60YIwJgyaOYg2z4JgFhfUYY0JDHdf77eoxQ44Z8uPaDrRgjAmTJo5iDTPkmCGF9RhjQkcd1zBDjhnw49oOtGCMCaOYH9c2ZsAxM1dijAkthfXMgGOa/Li2KCzHGBNmbf4F2sI0OaZvLcaYSvDfmSbHNPirtFHhQowxoaeONX5cG5gGx3QoPhDFGFMJPM1zBdPgmAaFqzHGVA7HlUyD4wj8uLYBCzHGVJImP65tHIHjyHyMMZUnz+UcgWMKflwbFC7EGFNx1NHux7WBKTim1g5EMcZUonqUdqbgmNpFGGMql3AhU3BMwl+jCxTaMMZULIVll63UBUzCYzJ5OgAPUxKRCNQfA8c2QPRoiER4j2wW3n4bXv8NjIxgzHR5eaEDuI0JeEwmzwpMUdTVwceb4aQmWPgfYcGJ0NgILsK0DL8JAwPwy1/Ayy9B30/h9d9gzITEsQK4jQkIE/BXaaMqvwY8TEHM+wB8Ygl86jQ4JQZ1dRTUr38Fvc/AM0/DwC8wZryc5Dg+eFAGOYzHRJRzAA8zZyd9DM5cBp/5T+AiFM3xJ8C558O558PL/fCjx+Anz8DICCV16iK49HI45hjK7p9fgbvuhDeGqHUeEc4BAg7jMbEVmDn5+MnwXy+E5j+h5E5qgpOa4MKL4JGH4InHYWSEolv257D6YnARQuGUGLR3QOe3McJ5QMBhIhzGj2tU4X8DR2Fm7EMfgks+D6svgcbjKKtoFBYthk+dBr8cgMGDFM2KC2DlKhBHqAy9Ds88jYH5rU2JW9N9yTzjeLzf6UA9ZsZO+wxcejnMm0eoHH8CXHcDPPE43H8PjIxQMHV1cMVVcNqnMeHWQJQ24HHG8TiMCstRzAxEIrD6Evizswi1M5dB8ylw6y0weJA5m/cB+NJaOCWGqQAKy4HHGcfjMAJnKGa6olG4ei0sWkxFOP4E+B+3wJ23wd49zFrjcXDNdXD8CRTU4EHo3Az7X4E/PhE+/0X4D3+EKYw/4zCOcfy4NqiyBDMt0Shccx0sWkxFmTcP1q6DRYuZlY98FK5PwPEnUFAvvwQb/hr27IY334S+fXDLBsiPYgoj5ndoI+M43qsNMy11dbB2HXzsZCpSXR38t2ug+RRmZNFiuD4BH/wQBbVnN9yyAd4Y4j1e/w283I8pDA+P0xnHMY5CG2ZavvQVaD6FilZXB19aC43HMS2nnwFfWQdHRymoH/0j3LYRRkaYUD6PKZQ8bYzjGEfgNMwRfe48WNxKVag/Btaug7o6prTiArjiL8FFKKh/eADu3QKjo5gSUMdpjOM4xF+p9QpLMFP6yEJoX0HRvP0WvNwPu5+H53vh+V7Yl4HXDkB+lKJYcCKsuJAJ1dXBFVfBuedTUCMjsOl2eOi7mNJacvlqjXKIx+94xFA8zKTq6uCKv4S6Ogqqbx88vRP2ZeDgQSYVjcJJTfCJT8Fpn4b6YyiYs86GnzwDL7/E70WjcPVaWLSYgnonC7f/L9i7B1N6Xj7PEmAnYzz+3RLMlM5cBh/5KAXz9E7o3gGvHmBaslnYm4G9GUhthTOXwefOg2OPZc6cg0svh+T1MDoKjcfBV9bBH59IQQ0ehNs2wsAvMGWShxZgJ2M8fkdZgplUXR187jwK4rVX4dub4J9eZNZGRuAffwBPPA6rL4EzlzFnH/kofPp02P8KrF0HjcdRUL/8BXxjIwwexJSREz7JIR7/7pOYSZ25DI49ljnbsxs23QFvv0VBjIxA52bYl4EvXg11dcxJ+wo45hg4OkpB7cvA7bdCNosps7yyhEMcY3xfPYVmzKTOOps56/2/cNtGePstCu4nz8Dtt8LICHPSeBwcHaWgnt4J3/hbyGYx4dB8+WqNMsbxrndoBjzMhBYthsbjmJM9u2HT7TA6StHs2Q133gb5UULj+9+Fu+6EkRFMeHh5pZkxjncpMcykTvsMczJ4EDbdAaOjFF36OejeQdnlR6FzM+x4ABNCCjHGOMZohGbMhCIR+MQS5mTL3fD2W5TMIw/B/lcom5ER+MZGeOJxTEjpKE2McYyRUZoxE/rIR2HePGbtuV7Yu4eSGh2F1H2UxRtD8DcJ2LMbE2LiOIkxjn9zEmZCHzuZOel+kLLo2wd9+yip116FDX8N//wKJvyaGeMYo7AQM6GTPsasvdwPP/8ZZfPjJyiZvn2w4QYYPIipAApNjPH8i7RBR2nETGjBiczacz+hrNLPQ34UXISieq4XNt0OIyOYytHw+ZVa78izADOpD36QWduXoazefgte+ieK6pGH4M7bYGQEU2G0joUOZQFmQtEozPsAs5LPw89/Rtn9bD9FkR+F7V2wvQtGRzEVSPMs8BAWoJgJ1B/DrA0ehNFRyu61Vym4kRHYdDs814upYAoLPIX5mIJ7801C4Y0hCurtt+H2W6FvH6byzfckz3wVTIHlRgiFfJ6CGTwIG/8GXj2AqQJO+LCH0IAxR7D/Fbj9Vnj9dUyVUJjvAR/GmCns2Q133gbZLKaaKA0e0IAxk/jxE9C5GUZHMdWnwQMaMGYC+zLwnb/HVCmFegdEMWYC72Qx1a3eKdRjjKlFDQ7wMMbUJAfUY4ypRfUO8DDG1CLPYYypWQ5jTM1yGGNqlgNyGGNqkgOGMcbUoiGHMaZW5ZzAEMaYWjTsgGGMMbUo64BhjDE1R2DIAUMYY2rRkAPewBhTe4RBBxzAGFN7lCGncABjTM1ReNUJDGKMqT3CAQcMYIypOaIMOIQBjDE1R2DAEWE/xpiaoyMMuGCrDCMMYYypJYPBDhlyjBGlH2NMLdnPGMe7lBcxxtQMEfoZ4xijHv0YY2qGjvIiYxxjJE8/xpiaIY4+xjjeJWQwxtQMgQxjHO/K0wfkMMbUgpxm6WOMY0yQkizQhzGmFvQF3ZJjjOMQgWcxxlQ9gV4OcRyiQi/GmKqn8CyHOA4RSGOMqXpO6OUQx+8ovUAOY0w1y2mODIc4DglSkhXoxRhTzXqD7TLMIY7xHM9gjKlaArsYxzFenh6MMdXsScZxjOexE8hhjKlKIvQwjmOcYKsMIqQxxlSj3i1dMsQ4jvd7EmNM1RHo4TCOwwg8ijGmGj3GYRyHO5oeYAhjTDUZBnZyGMdhgkByAj0YY6qGQE+QkiyHcUxE+B7GmKqhsIMJOCYS4WEghzGmGuSc42Em4JhAsFUGBXZhjKl4Aru23C+DTMAxCXXswBhT8TTPDibhMQlxPKh5NgIeNWpkBF78KbPy8/2Ewpv/D178KbMyMEAo/Hw/szYwQK3LOeVBJiFMwY/rDxSWY4ypSCI8HnTJZ5mEYyrCNowxFUuV+5iCYypKNzCMMaYSZZ3QzRQcUwhSMiSObowxFUcgtaVLhpiC40jybMYYU4nu4wgcRxCkpAfoxxhTSfYHKXmcI3BMh+MujDGV5E6mwTENkufbQA5jTCXIOkfANDimIUjJkDi2YowJPYHUlvtlkGlwTNco38QYUwm+yTQ5pinYJmmgB2NMaAk8GqQkzTQ5ZkAgiTEmvIS7mAHHDAQp6UHIYIwJHYF00CXdzIBjhkS4FWNM+AhJZsgxU0exFejHGBMaAumgS7qZIccMBYHkxHETxpjwEJLMgmM2jmIr0I8xpuwE0kGXdDMLjlkIAsmJkMQYU35CkllyzFLQJVuBXRhjykYgHXRJN7PkmAOBr2KMKR/hq8yBYw6ClPQAj2KMKYfuoEseZQ4ccyQeXwZyGGNKKSuQZI4izFH6heTrLbHEh4GlGGNKQuDvgpR0MkeOAhBIAAcwxpTCAafcQAE4CiBIyZAI6zDGlMK672yTYQrAUSBBl2wFdmKMKaaezpRspUAcBSR1fAHIYowphqzkuIoCilBA6ReSgy2LEgL8Z4wxBSVwY/CA7KCAHAUmR3MLQhpjTMEIpIGvU2COAgsCyYnHZUAOY0whZIHLgpRkKbAIRZB+IXmgZVFiBFiGMWZOBG4MUrKNInAUiRzN/wR2YYyZNYFdwNcpEkeRBIHkEC4GhjHGzEY2D6uClGQpkghFtDuTfL311MSvEdoxxsyICJd1puTHFFGEIkvvTaZb/jSxEKUFY8z05Ak6t8kGisxRApLnKqAPY8x09InjKkrAUQJBSrJSx/nAMMaYqWRRzg1SkqUEIpRI+oXkYGss8RJwAcaYCYmwsjMlT1EiEUoonUnua4klBGjDGHO4GztTsokScpSYRLkReBhjzHgPd6bkBkrMUWJBIDlxrAIyGGPelRZYSRlEKIP0nuRvF8cSPxDoAP4QY2rXfoWzO1MySBlEKJPdmeRQa0vi/5BnNXAUxtSerIzy2c4HpI8yiVBG6ReSv2qNJZ4HOgAPY2pHVuD84AHZSRlFKLN0JtnfuijxMtCBMTVCHKuCLnmIMosQAulMMtN6auIthLMwpsopXNvZJZsJgQghkd6bfGpxLIFAG8ZUKYXEPSm5mZCIECK7M8knF8cSCLRhTJVRSNyTkiQhEiFkdmeSTy6OJRBow5gqoZC4JyVJQiZCCO3OJJ9cHEsg0IYxFU4hcU9KkoRQhJDanUk+uTiWQKANYyqUQuKelCQJqQghtjuTfLI1lngLOAtjKozCtfek5GZCLELIpTPJp1r/NLEX5b8AHsaEX1YcF3d2yd2EXIQKkN6T3NcaSzwLdAAexoTXsMCKoEu6qQARKkQ6k+xvbU08Qp7lQAPGhM+A5Dg7eEB+TIWIUEHSLyQPLI4lvidCGzAfY8JCyCh8tvMB2UcFiVBhdmeSQ62xRCfQAnwcY8rvYXGc3dklr1FhhAp2aVw3AF/DmHJREvIONwXdkqMCCRXOj2u7QhcQxZjSGRa4OEhJNxUsQoVLZ5J9LYsS24CzgEaMKb4+lDM6t8lTVLgIVWB3Jvl6ayyxGccClBaMKZY8gQjndm6T16gCQpXx47pG4W4gijGFMwx8uTMlAVVEqEKXxHWhQBewFGPmSGCXKhd3bpN+qkyEKrQ7kxxqjSXuExgFlgIexsxcTpTreYcvdO6QQaqQUOX8uLYobAFaMGb60jLKZcF2SVPFIlS5dCZ5oDWW6BQYBZYCHsZMLitCQrJcGvyD/IoqJ9QQ/2Jt1hE2AW0YcxiBHnJcFTwofdQIoQb5cV2jsBGYjzFwgBzrOh+UrdQYoUb5K7WeCDcqXAlEMbUoh/J3zpHc0iVD1CChxvlxbVFYD7Rjasmj5Phy54PSTw0TzL/yV+lyVW4GWjBVS2AXwleDLunBIJj38OParrAeaMFUk34Z5YZgu6QwvyeYCflxbVdYD7RgKlk/OW6SHFuDbslh3kMwU/Lj2q6wHmjBVA4hwwi3So6tQbfkMBMSzLT4cW0HrlRYjgktgR6EZNAlPZgjEsyM+HFtAdYqXAhEMWGQI89WcdwapCSDmTbBzMplq7VR8/gKVwMLMeXQLznukjq+vaVLhjAzJpg581drG3l8hQuBKKaYhsnTLRE2B13Sg5kTwRTMZau0Ia+0i3CRKm2AhymEnMDjCtuc0L2lS4YwBSGYovA7dAHQoR4rgKWAh5mJnAi7GGGHCA9u2S4DmIITTNFdtlob83nOEVih0AbUYyYyBPQA33OjPLxluwxiikowJeXHNYpwOvDnCm0oS6hdOYS0QA/wGP9CT9AtOUzJCKasLlulDaq0IZyhsBRlCeBRnXIIvZJnlwpPulF2btkug5iyEUyo+Ku1HiWmsETgk6osAZoBj8qSA/qc0JuHZ0VJRxy9m++XLCY0BBN6frt6Mo/mfJ6Y5GimjpNVaQIWAo2UkzCE0i9CHyO8rHX0OyHjoG/z/ZLFhJpgKpq/UhukjgWaZ4EKC4D5An8ENKA0KjQADUAUqAc8oB7weK8cMMy/GQKGgWGBIYQhgQN55VWEQVEGxDEgI+z/znYZxlSs/w9y4mYe+W/wkgAAAABJRU5ErkJggg==",
  "link": "https://mavryk.org/wallet"
}, {
  "key": "mavryk_firefox",
  "id": "{34ac229e-1cf5-4e4c-8a77-988155c4360f}",
  "name": "Mavryk Wallet Firefox",
  "shortName": "Mavryk",
  "color": "",
  "logo": "data:image/png;base64,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",
  "link": "https://mavryk.org/wallet"
}];
const desktopList = [];
const webList = [];
const iOSList = [];

var _tmpl$$b = /*#__PURE__*/template(`<svg stroke-width=0 xmlns=http://www.w3.org/2000/svg viewBox="0 0 512 512"height=1em width=1em><path d="m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34Z">`),
  _tmpl$2$9 = /*#__PURE__*/template(`<svg stroke-width=0 xmlns=http://www.w3.org/2000/svg viewBox="0 0 320 512"height=1em width=1em><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z">`),
  _tmpl$3$9 = /*#__PURE__*/template(`<svg xmlns=http://www.w3.org/2000/svg id=Guides x=0 y=0 version=1.1 viewBox="0 0 179.2 43"width=140 height=40><path fill=#3880FF d="M45 19v.9c0 .3-.2 7.5-3.4 13.2-3.3 5.6-9.4 9.3-9.7 9.5l-.8.4-1.3-.8-7.6-4.4c-.5-.3-.9-.6-1.4-.9-.4-.3-.7-.5-1.1-.8-.8-.7-1.5-1.4-2.1-2.2-.9-1.1-1.6-2.4-2.1-3.7-.9-2.3-1.3-4.8-1.2-7.5.8-.4 1.6-.6 2.4-.6h.6c-.2 2.4.1 4.6.8 6.6 1 2.8 2.9 5.1 5.5 6.6l7.4 4.3c.2-.1.4-.2.6-.4 1.9-1.3 5.3-4.1 7.3-7.6 2.2-3.9 2.8-8.9 3-10.8L38.8 19c.3-1 .4-2.1.5-3.2L45 19z"class=st0></path><path fill=#3880FF d="M36.3 4.1v10.3c0 .5 0 1.1-.1 1.6s-.1.9-.2 1.3c-.2 1-.5 2-.9 3-.5 1.3-1.3 2.6-2.2 3.7-1.5 1.9-3.5 3.6-5.9 4.8-.9-.6-1.6-1.3-2-2.4 2.1-1 3.9-2.3 5.2-4 1.9-2.3 3-5.1 3-8.1V5.9l-.6-.3c-2-1-6.1-2.6-10.1-2.6-4.5 0-9.1 2-10.9 2.9v3.6c-1 .3-2 .7-3 1.1V4.1l.8-.4C9.7 3.5 16 0 22.5 0s12.8 3.5 13.1 3.6l.7.5z"class=st0></path><path fill=#3880FF d="M10.5 16.5l-7.4 4.3v.7c.2 2.1.9 6.5 2.9 10 2.2 3.9 6.2 6.9 7.9 8l3.1-1.8c.8.7 1.6 1.4 2.5 2L13.8 43l-.8-.5c-.3-.2-6.4-3.9-9.7-9.5C.1 27.4 0 20.2 0 19.9V19l1.3-.8L9 13.9c.5-.3.9-.5 1.4-.7.4-.2.8-.4 1.3-.5 1-.4 2-.6 3-.7 1.4-.2 2.9-.2 4.3 0 2.4.3 4.8 1.2 7.1 2.7 0 1-.4 2-1 2.9-1.9-1.3-4-2.2-6-2.5-3.1-.6-6-.1-8.6 1.4z"class=st0></path><g><path d="M73.9 23c.9 1 1.3 2.3 1.3 3.7 0 1.9-.6 3.4-1.9 4.5-1.3 1.1-3.1 1.7-5.5 1.7h-8.6v-23h8.4c2.3 0 4.1.5 5.3 1.5 1.2 1 1.8 2.4 1.8 4.2 0 1.5-.4 2.7-1.2 3.6-.8.9-1.8 1.5-3.1 1.8 1.5.3 2.6 1 3.5 2zm-11.7-3h5c1.5 0 2.6-.3 3.4-1 .8-.7 1.2-1.6 1.2-2.8 0-1.2-.4-2.1-1.1-2.8-.8-.7-1.9-1-3.5-1h-4.8V20zm8.7 9.4c.9-.7 1.3-1.7 1.3-3s-.4-2.3-1.3-3c-.9-.7-2.1-1.1-3.7-1.1h-5v8.2h5c1.6-.1 2.8-.4 3.7-1.1zM95.3 24.6H81c.1 2.1.6 3.6 1.7 4.6s2.4 1.5 4 1.5c1.4 0 2.6-.4 3.6-1.1 1-.7 1.6-1.7 1.8-2.9h3.2c-.2 1.2-.7 2.4-1.5 3.3-.8 1-1.7 1.7-2.9 2.3-1.2.5-2.6.8-4.1.8-1.7 0-3.2-.4-4.6-1.1-1.3-.7-2.4-1.8-3.1-3.2-.8-1.4-1.1-3-1.1-4.9 0-1.9.4-3.5 1.1-4.9.8-1.4 1.8-2.5 3.1-3.2 1.3-.7 2.9-1.1 4.6-1.1 1.7 0 3.3.4 4.6 1.1 1.3.7 2.3 1.7 3 3 .7 1.2 1 2.6 1 4.1.1.7 0 1.2-.1 1.7zm-3.5-4.8c-.5-.9-1.2-1.6-2.1-2-.9-.4-1.8-.7-2.8-.7-1.6 0-3 .5-4.1 1.5-1.1 1-1.7 2.5-1.8 4.5h11.5c0-1.3-.2-2.4-.7-3.3zM111.2 16c1.2.9 2.1 2 2.5 3.5V15h3v18h-3v-4.6c-.5 1.5-1.3 2.6-2.5 3.5-1.2.9-2.7 1.3-4.4 1.3-1.6 0-3-.4-4.3-1.1-1.2-.7-2.2-1.8-2.9-3.2-.7-1.4-1.1-3-1.1-4.9 0-1.9.4-3.5 1.1-4.9.7-1.4 1.7-2.5 2.9-3.2 1.2-.7 2.7-1.1 4.3-1.1 1.7-.1 3.1.4 4.4 1.2zm-8 3.1c-1.1 1.2-1.7 2.8-1.7 4.8 0 2.1.5 3.7 1.7 4.8 1.1 1.2 2.6 1.8 4.4 1.8 1.2 0 2.2-.3 3.2-.8.9-.5 1.7-1.3 2.2-2.3.5-1 .8-2.1.8-3.5 0-1.3-.3-2.5-.8-3.5s-1.2-1.8-2.2-2.3c-.9-.5-2-.8-3.2-.8-1.9.1-3.3.7-4.4 1.8zM135 16.6c1.5 1.2 2.4 2.9 2.8 4.9h-3.1c-.2-1.3-.8-2.3-1.8-3-1-.7-2.2-1.1-3.6-1.1-1 0-2 .2-2.9.7-.9.5-1.6 1.2-2.1 2.2-.5 1-.8 2.2-.8 3.7s.3 2.7.8 3.7 1.2 1.7 2.1 2.2c.9.5 1.8.7 2.9.7 1.4 0 2.6-.4 3.6-1.1 1-.7 1.6-1.8 1.8-3h3.1c-.3 2.1-1.3 3.7-2.8 4.9-1.5 1.2-3.4 1.8-5.7 1.8-1.7 0-3.2-.4-4.6-1.1-1.3-.7-2.4-1.8-3.1-3.2-.8-1.4-1.1-3-1.1-4.9 0-1.9.4-3.5 1.1-4.9.8-1.4 1.8-2.5 3.1-3.2 1.3-.7 2.9-1.1 4.6-1.1 2.3-.1 4.2.6 5.7 1.8zM154.5 15.9c1.4.7 2.4 1.8 3.2 3.2.8 1.4 1.2 3 1.2 4.9 0 1.9-.4 3.5-1.2 4.9-.8 1.4-1.8 2.4-3.2 3.2-1.4.7-2.9 1.1-4.6 1.1-1.7 0-3.3-.4-4.6-1.1-1.4-.7-2.4-1.8-3.2-3.2-.8-1.4-1.2-3-1.2-4.9 0-1.9.4-3.5 1.2-4.9.8-1.4 1.9-2.5 3.2-3.2 1.4-.7 2.9-1.1 4.6-1.1 1.7-.1 3.2.3 4.6 1.1zm-7.6 2.2c-.9.5-1.6 1.2-2.2 2.2-.6 1-.8 2.2-.8 3.7 0 1.4.3 2.7.8 3.6.6 1 1.3 1.7 2.2 2.2.9.5 1.9.7 3 .7s2.1-.2 3-.7c.9-.5 1.6-1.2 2.2-2.2.6-1 .8-2.2.8-3.6 0-1.5-.3-2.7-.8-3.7-.6-1-1.3-1.7-2.2-2.2-.9-.5-1.9-.7-3-.7s-2.1.2-3 .7zM177.3 16.7c1.3 1.3 1.9 3.3 1.9 5.8v10.4h-3V22.8c0-1.8-.5-3.2-1.4-4.1-.9-1-2.2-1.4-3.7-1.4-1.6 0-2.9.5-3.9 1.6s-1.5 2.6-1.5 4.6V33h-3V15h3v4.3c.5-1.5 1.3-2.6 2.4-3.4 1.2-.8 2.5-1.2 4-1.2 2.2 0 3.9.6 5.2 2z"class=st1>`),
  _tmpl$4$8 = /*#__PURE__*/template(`<svg xmlns=http://www.w3.org/2000/svg viewBox="0 0 448 512"><path d="M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z">`);
function CloseIcon(props) {
  return (() => {
    var _el$ = _tmpl$$b();
    effect(_$p => style(_el$, props.style ? {
      overflow: 'visible',
      'font-size': '22px',
      ...props.style
    } : {
      overflow: 'visible',
      'font-size': '22px'
    }, _$p));
    return _el$;
  })();
}
function LeftIcon(props) {
  return (() => {
    var _el$2 = _tmpl$2$9();
    effect(_$p => style(_el$2, props.style ? {
      overflow: 'visible',
      ...props.style
    } : {
      overflow: 'visible'
    }, _$p));
    return _el$2;
  })();
}
function LogoIcon(props) {
  return (() => {
    var _el$3 = _tmpl$3$9();
    effect(_$p => style(_el$3, props.style ? {
      ...props.style
    } : {}, _$p));
    return _el$3;
  })();
}
function QRCodeIcon() {
  return _tmpl$4$8();
}

var styles$9 = ".loader {\n  height: 3px;\n  position: relative;\n  background-color: #ddd;\n  position: absolute;\n  width: 100%;\n  left: 0px;\n  bottom: 0px;\n  overflow: hidden;\n}\n\n.loader:before {\n  content: '';\n  position: absolute;\n  left: -50%;\n  height: 3px;\n  width: 40%;\n  background-color: #3880ff;\n  -webkit-animation: lineAnim 1s linear infinite;\n  -moz-animation: lineAnim 1s linear infinite;\n  animation: lineAnim 1s linear infinite;\n}\n\n@keyframes lineAnim {\n  0% {\n    left: -40%;\n  }\n  50% {\n    left: 20%;\n    width: 80%;\n  }\n  100% {\n    left: 100%;\n    width: 100%;\n  }\n}\n";

var _tmpl$$a = /*#__PURE__*/template(`<div class=loader>`);
const Loader = _ => {
  return _tmpl$$a();
};

var _tmpl$$9 = /*#__PURE__*/template(`<div><div><div class=alert-header><div class=alert-logo></div><div class=alert-button-icon></div></div><div class=alert-modal-loading-wrapper></div><div class=alert-body>`),
  _tmpl$2$8 = /*#__PURE__*/template(`<div class=alert-button-icon>`),
  _tmpl$3$8 = /*#__PURE__*/template(`<div class=alert-button-icon-empty>`),
  _tmpl$4$7 = /*#__PURE__*/template(`<div>`),
  _tmpl$5$5 = /*#__PURE__*/template(`<div class=alert-divider>`),
  _tmpl$6$4 = /*#__PURE__*/template(`<div class=alert-footer>`);
const Alert = props => {
  let prevBodyOverflow = null;
  onMount(() => {
    prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  });
  onCleanup(() => {
    document.body.style.overflow = prevBodyOverflow;
  });
  const isMobile = window.innerWidth <= 800;
  return (() => {
    var _el$ = _tmpl$$9(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.firstChild,
      _el$5 = _el$4.nextSibling,
      _el$6 = _el$3.nextSibling,
      _el$7 = _el$6.nextSibling;
    _el$.$$click = () => {
      props.onCloseClick();
    };
    _el$2.$$click = e => {
      e.stopPropagation();
    };
    insert(_el$3, (() => {
      var _c$ = memo(() => !!props.onBackClick);
      return () => _c$() && (() => {
        var _el$8 = _tmpl$2$8();
        addEventListener(_el$8, "click", props.onBackClick, true);
        insert(_el$8, createComponent(LeftIcon, {}));
        return _el$8;
      })();
    })(), _el$4);
    insert(_el$3, (() => {
      var _c$2 = memo(() => !!!props.onBackClick);
      return () => _c$2() && _tmpl$3$8();
    })(), _el$4);
    insert(_el$4, createComponent(LogoIcon, {}));
    addEventListener(_el$5, "click", props.onCloseClick, true);
    insert(_el$5, createComponent(CloseIcon, {}));
    insert(_el$6, createComponent(Loader, {}));
    insert(_el$7, () => props.content, null);
    insert(_el$7, !isMobile && (() => {
      var _el$10 = _tmpl$4$7();
      insert(_el$10, (() => {
        var _c$4 = memo(() => !!props.extraContent);
        return () => _c$4() && _tmpl$5$5();
      })(), null);
      insert(_el$10, () => props.extraContent, null);
      effect(() => className(_el$10, props.showMore ? 'alert-body-extra-show' : 'alert-body-extra-hide'));
      return _el$10;
    })(), null);
    insert(_el$2, (() => {
      var _c$3 = memo(() => !!(!isMobile && props.extraContent));
      return () => _c$3() && (() => {
        var _el$12 = _tmpl$6$4();
        _el$12.$$click = () => {
          if (props.onClickShowMore) props.onClickShowMore();
        };
        insert(_el$12, () => props.showMore ? 'Show less' : 'Show more');
        return _el$12;
      })();
    })(), null);
    effect(_p$ => {
      var _v$ = props.open ? 'alert-wrapper-show' : 'alert-wrapper-hide',
        _v$2 = props.open ? 'alert-modal-show' : 'alert-modal-hide',
        _v$3 = props.loading ? {
          opacity: 1,
          transition: 'all ease 0.3s',
          height: '14px',
          overflow: 'unset',
          width: 'unset'
        } : {
          opacity: 0,
          transition: 'all ease 0.3s',
          height: 0,
          overflow: 'hidden',
          width: 0
        },
        _v$4 = props.extraContent ? '' : '1.8em';
      _v$ !== _p$.e && className(_el$, _p$.e = _v$);
      _v$2 !== _p$.t && className(_el$2, _p$.t = _v$2);
      _p$.a = style(_el$6, _v$3, _p$.a);
      _v$4 !== _p$.o && ((_p$.o = _v$4) != null ? _el$7.style.setProperty("margin-bottom", _v$4) : _el$7.style.removeProperty("margin-bottom"));
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined
    });
    return _el$;
  })();
};
delegateEvents(["click"]);

var styles$8 = ".wallet-main {\n  display: flex;\n  gap: 1.25em;\n  justify-content: space-between;\n  border-radius: 12px;\n  padding: 15px;\n  cursor: pointer;\n  transition: all ease 0.2s;\n\n  -webkit-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  -moz-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n}\n\n.wallet-disabled {\n  opacity: 0.5;\n}\n\n.wallet-main:hover {\n  transform: scale(1.01);\n}\n\n.wallet-main:active {\n  transform: scale(0.99);\n}\n\n.wallet-main-left {\n  max-width: 148px;\n  flex: 1;\n}\n\n.theme__dark .wallet-main-left h3 {\n  color: white;\n}\n\n.theme__dark .top-wallets-info p {\n  color: #b5b8be;\n}\n\n.theme__dark .wallet-small img {\n  -webkit-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 63%);\n  -moz-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 63%);\n  box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 63%);\n}\n\n.theme__dark .wallet-small h3 {\n  color: white;\n}\n\n.wallet-main-left h3 {\n  color: #1c1e21;\n  margin: 0px;\n  font-size: 1em;\n}\n\n.wallet-main-left p {\n  max-width: 400px;\n  font-weight: 300;\n  color: #7c828b;\n  line-height: 1.35em;\n  margin: 0px;\n  font-size: 0.65em;\n}\n\n.wallet-main-right {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.wallet-main-right img {\n  width: 3.2em;\n  height: 3.2em;\n}\n\n.wallet-main-tags {\n  display: flex;\n  gap: 6px;\n}\n\n.wallet-main-tag {\n  color: #3880ff;\n  margin: 0px;\n  font-size: 0.75em;\n  font-weight: 600;\n  margin-top: 6px;\n  text-transform: uppercase;\n}\n\n.wallet-small {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 0.5em;\n}\n\n.wallet-small img {\n  padding: 0.4em;\n  border-radius: 10px;\n  width: 2.5em;\n  height: 2.5em;\n  cursor: pointer;\n  transition: all ease 0.2s;\n\n  -webkit-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  -moz-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n}\n\n.wallet-small img:hover {\n  transform: scale(1.01);\n}\n\n.wallet-small img:active {\n  transform: scale(0.99);\n}\n\n.wallet-small h3 {\n  color: #334155;\n  margin: 0px;\n  font-size: 0.8em;\n  text-align: center;\n}\n\n.wallet-main-mobile {\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1em;\n}\n\n.wallet-main-left-mobile {\n  order: 1;\n}\n\n.wallet-main-left-mobile h3 {\n  font-size: 0.9em;\n  text-align: center;\n}\n\n.wallet-main-left-mobile p {\n  font-size: 0.65em;\n  text-align: center;\n}\n\n@media only screen and (max-width: 800px) {\n  .wallet-main {\n    padding: 0.65em 15px;\n  }\n\n  .wallet-main-mobile {\n    padding: 1.25em;\n  }\n}\n";

var _tmpl$$8 = /*#__PURE__*/template(`<div>`),
  _tmpl$2$7 = /*#__PURE__*/template(`<div><div><h3></h3></div><div class=wallet-main-right><img>`),
  _tmpl$3$7 = /*#__PURE__*/template(`<p>`),
  _tmpl$4$6 = /*#__PURE__*/template(`<div class=wallet-main-tags>`),
  _tmpl$5$4 = /*#__PURE__*/template(`<span class=wallet-main-tag>`),
  _tmpl$6$3 = /*#__PURE__*/template(`<div class=wallet-small><img><h3>`);
const Wallet = props => {
  return (() => {
    var _el$ = _tmpl$$8();
    insert(_el$, (() => {
      var _c$ = memo(() => !!!props.small);
      return () => _c$() && (() => {
        var _el$2 = _tmpl$2$7(),
          _el$3 = _el$2.firstChild,
          _el$4 = _el$3.firstChild,
          _el$5 = _el$3.nextSibling,
          _el$6 = _el$5.firstChild;
        addEventListener(_el$2, "click", props.onClick, true);
        insert(_el$4, () => props.name);
        insert(_el$3, (() => {
          var _c$3 = memo(() => !!props.description);
          return () => _c$3() && (() => {
            var _el$7 = _tmpl$3$7();
            insert(_el$7, () => props.description);
            return _el$7;
          })();
        })(), null);
        insert(_el$3, (() => {
          var _c$4 = memo(() => !!(props.tags && props.tags.length > 0));
          return () => _c$4() && (() => {
            var _el$8 = _tmpl$4$6();
            insert(_el$8, createComponent(For, {
              get each() {
                return props.tags;
              },
              children: tag => (() => {
                var _el$9 = _tmpl$5$4();
                insert(_el$9, tag);
                return _el$9;
              })()
            }));
            return _el$8;
          })();
        })(), null);
        effect(_p$ => {
          var _v$ = `wallet-main ${props.mobile ? 'wallet-main-mobile' : ''}`,
            _v$2 = `wallet-main-left ${props.mobile ? 'wallet-main-left-mobile' : ''}`,
            _v$3 = props.image;
          _v$ !== _p$.e && className(_el$2, _p$.e = _v$);
          _v$2 !== _p$.t && className(_el$3, _p$.t = _v$2);
          _v$3 !== _p$.a && setAttribute(_el$6, "src", _p$.a = _v$3);
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined
        });
        return _el$2;
      })();
    })(), null);
    insert(_el$, (() => {
      var _c$2 = memo(() => !!props.small);
      return () => _c$2() && (() => {
        var _el$10 = _tmpl$6$3(),
          _el$11 = _el$10.firstChild,
          _el$12 = _el$11.nextSibling;
        addEventListener(_el$10, "click", props.onClick, true);
        insert(_el$12, () => props.name);
        effect(() => setAttribute(_el$11, "src", props.image));
        return _el$10;
      })();
    })(), null);
    effect(() => className(_el$, props.disabled ? 'wallet-disabled' : ''));
    return _el$;
  })();
};
delegateEvents(["click"]);

var styles$7 = ".top-wallets-wrapper {\n  margin-bottom: 1.8em;\n}\n\n.top-wallets-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.theme__dark .top-wallets-info h3 {\n  color: white;\n}\n\n.theme__dark .top-wallets-info span {\n  color: #b5b8be;\n}\n\n.theme__dark .top-wallets-other-wallets-left h3 {\n  color: white;\n}\n\n.top-wallets-info h3 {\n  text-align: center;\n  color: #334155;\n  margin: 0px;\n  font-size: 0.938rem;\n}\n\n.top-wallets-info span {\n  text-align: center;\n  max-width: 300px;\n  font-size: 0.8em;\n  font-weight: 300;\n  color: #7c828b;\n  line-height: 1.35em;\n  margin: 6px 0px 12px 0px;\n}\n\n.top-wallets-learn-more {\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.95em !important;\n}\n\n.top-wallets-wallets-main {\n  margin-top: 1em;\n  grid-template-columns: repeat(2, 1fr);\n  display: grid;\n  gap: 1em;\n}\n\n.top-wallets-other-wallets {\n  display: flex;\n  gap: 1.25em;\n  justify-content: space-between;\n  border-radius: 12px;\n  padding: 1.25em;\n  cursor: pointer;\n  transition: all ease 0.2s;\n\n  -webkit-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  -moz-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n}\n\n.top-wallets-other-wallets-left {\n  max-width: 148px;\n}\n\n.top-wallets-other-wallets-left h3 {\n  color: #334155;\n  margin: 0px;\n  font-size: 1em;\n}\n\n.top-wallets-other-wallets-left p {\n  max-width: 400px;\n  font-size: 0.85em;\n  font-weight: 300;\n  color: #94a3b8;\n  line-height: 1.35em;\n  margin: 0px;\n  font-size: 0.75em;\n}\n\n.top-wallets-other-wallets-right {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.top-wallets-other-wallets-right img {\n  border-radius: 8px;\n  width: 2.4em;\n  height: 2.4em;\n  -webkit-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  -moz-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n}\n\n.top-wallets-other-wallets-center-wallet {\n  transform: perspective(500px) translateZ(100px);\n}\n\n@media only screen and (max-width: 800px) {\n  .top-wallets-info h3 {\n    font-size: 1em;\n  }\n\n  .top-wallets-info p {\n    font-size: 0.75em;\n  }\n\n  .top-wallets-other-wallets {\n    flex-direction: column;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .top-wallets-other-wallets-left {\n    order: 1;\n  }\n\n  .top-wallets-other-wallets-left h3 {\n    font-size: 0.85em;\n  }\n\n  .top-wallets-other-wallets-left p {\n    font-size: 0.65em;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .top-wallets-other-wallets-right {\n    max-width: 50px;\n    transform: scale(0.8);\n  }\n}\n";

var _tmpl$$7 = /*#__PURE__*/template(`<div class=top-wallets-wrapper><div class=top-wallets-info><h3>Connect Wallet</h3></div><div class=top-wallets-wallets-main>`),
  _tmpl$2$6 = /*#__PURE__*/template(`<span>Do you wish to report a bug? <span class=top-wallets-learn-more>Click here`),
  _tmpl$3$6 = /*#__PURE__*/template(`<span>If you don't have a wallet, you can select a provider and create one now. <span class=top-wallets-learn-more>Learn more`),
  _tmpl$4$5 = /*#__PURE__*/template(`<div class=top-wallets-other-wallets><div class=top-wallets-other-wallets-left><h3>Other Wallets</h3><p>See other wallets you can use to connect</p></div><div class=top-wallets-other-wallets-right><img><img class=top-wallets-other-wallets-center-wallet><img>`);
const TopWallets = props => {
  const enableBugReport = localStorage ? localStorage.getItem(StorageKey.ENABLE_METRICS) : 'false';
  return (() => {
    var _el$ = _tmpl$$7(),
      _el$2 = _el$.firstChild;
      _el$2.firstChild;
      var _el$4 = _el$2.nextSibling;
    insert(_el$2, enableBugReport === 'true' && (() => {
      var _el$5 = _tmpl$2$6(),
        _el$6 = _el$5.firstChild,
        _el$8 = _el$6.nextSibling;
      _el$8.$$click = () => props.onClickLearnMore();
      return _el$5;
    })(), null);
    insert(_el$2, enableBugReport !== 'true' && (() => {
      var _el$9 = _tmpl$3$6(),
        _el$10 = _el$9.firstChild,
        _el$12 = _el$10.nextSibling;
      _el$12.$$click = () => props.onClickLearnMore();
      return _el$9;
    })(), null);
    insert(_el$4, createComponent(For, {
      get each() {
        return props.wallets;
      },
      children: wallet => createComponent(Wallet, {
        get disabled() {
          return props.disabled;
        },
        get mobile() {
          return props.isMobile;
        },
        get name() {
          return wallet.name;
        },
        get description() {
          return wallet.descriptions.join(' & ');
        },
        get image() {
          return wallet.image;
        },
        onClick: () => props.onClickWallet(wallet.id),
        get tags() {
          return wallet.tags;
        }
      })
    }), null);
    insert(_el$4, (() => {
      var _c$ = memo(() => !!props.otherWallets);
      return () => _c$() && (() => {
        var _el$13 = _tmpl$4$5(),
          _el$14 = _el$13.firstChild,
          _el$15 = _el$14.nextSibling,
          _el$16 = _el$15.firstChild,
          _el$17 = _el$16.nextSibling,
          _el$18 = _el$17.nextSibling;
        _el$13.$$click = () => {
          if (props.otherWallets) props.otherWallets.onClick();
        };
        effect(_p$ => {
          var _v$ = props.otherWallets.images[0],
            _v$2 = props.otherWallets.images[1],
            _v$3 = props.otherWallets.images[2];
          _v$ !== _p$.e && setAttribute(_el$16, "src", _p$.e = _v$);
          _v$2 !== _p$.t && setAttribute(_el$17, "src", _p$.t = _v$2);
          _v$3 !== _p$.a && setAttribute(_el$18, "src", _p$.a = _v$3);
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined
        });
        return _el$13;
      })();
    })(), null);
    return _el$;
  })();
};
delegateEvents(["click"]);

var styles$6 = ".wallets-button {\n  border-radius: 6px;\n  background-color: transparent;\n  border: 1px solid #3880ff;\n  color: #3880ff;\n  width: 100%;\n  padding: 12px 0px;\n  margin-bottom: 1.8em;\n  transition: all ease 0.2s;\n  cursor: pointer;\n  font-size: 0.9em;\n}\n\n.wallets-button:hover {\n  color: white;\n  background-color: #3880ff;\n}\n\n.wallets-list-main-wrapper {\n  position: relative;\n}\n\n.wallets-list-wrapper {\n  display: grid;\n  overflow-y: auto;\n  grid-template-columns: repeat(4, 1fr);\n  padding: 1.8em 0px;\n  gap: 1.2em 0em;\n  max-height: 180px;\n}\n\n@media only screen and (max-width: 800px) {\n  .wallets-list-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    max-height: 300px;\n    padding: 1.6em 0.6em;\n    margin-top: 0px;\n  }\n\n  .wallets-list-main-wrapper::before {\n    position: absolute;\n    top: 0px;\n    content: '';\n    left: -24px;\n    width: calc(100% + 48px);\n    background: radial-gradient(\n      circle,\n      rgba(171, 171, 171, 0.7329525560224089) 0%,\n      rgba(193, 193, 193, 0.1279105392156863) 100%\n    );\n    height: 1px;\n  }\n}\n";

var _tmpl$$6 = /*#__PURE__*/template(`<div class=wallets-list-main-wrapper><div class=wallets-list-wrapper></div><button class=wallets-button>`);
const Wallets = props => {
  return (() => {
    var _el$ = _tmpl$$6(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling;
    insert(_el$2, createComponent(For, {
      get each() {
        return props.wallets;
      },
      children: wallet => createComponent(Wallet, {
        get disabled() {
          return props.disabled;
        },
        get name() {
          return wallet.name;
        },
        get description() {
          return wallet.descriptions.join(' & ');
        },
        get image() {
          return wallet.image;
        },
        get small() {
          return props.small;
        },
        onClick: () => {
          if (props.onClickWallet) {
            props.onClickWallet(wallet.id);
          }
        }
      })
    }));
    _el$3.$$click = () => props.onClickOther();
    insert(_el$3, () => props.isMobile ? 'Pair wallet on another device' : 'Show QR code');
    return _el$;
  })();
};
delegateEvents(["click"]);

var styles$5 = ".info-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5em;\n  border-radius: 10px;\n  padding: 30px;\n}\n\n.info-border {\n  border: 1px solid #aaaaaa42;\n}\n\n.info-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 28px;\n  margin-bottom: 0.2em;\n}\n\n.info-badge {\n  background-color: #3880ff;\n  font-size: 38px;\n  -webkit-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  -moz-box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n  box-shadow: 0px 0px 12px -4px rgb(0 0 0 / 30%);\n}\n\n.theme__dark .info-title {\n  color: white;\n}\n\n.theme__dark .info-description {\n  color: #aeaeae;\n}\n\n.info-title {\n  text-align: center;\n  color: #334155;\n  margin: 0px;\n  font-size: 1em;\n}\n\n.info-description {\n  text-align: center;\n  font-size: 0.8em;\n  font-weight: 300;\n  color: #7c828b;\n  line-height: 1.25em;\n  margin: 6px 0px 12px 0px;\n  margin: 0px;\n  max-width: 300px;\n}\n\n.info-data {\n  font-size: 0.8em;\n  font-weight: 300;\n  color: #7c828b;\n  line-height: 1.25em;\n  margin: 6px 0px 12px 0px;\n  margin: 0px;\n  overflow: scroll;\n  max-height: 300px;\n}\n\n.info-buttons {\n  display: flex;\n  align-items: center;\n  gap: 0.6em;\n}\n\n.info-button {\n  border-radius: 6px;\n  background-color: #3880ff;\n  border: 1px solid #3880ff;\n  color: white;\n  padding: 0.6em 1.2em;\n  width: 180px;\n  transition: all ease 0.2s;\n  cursor: pointer;\n  margin-top: 1em;\n  font-size: 0.8em;\n}\n\n.info-button:hover {\n  background-color: #166afc;\n}\n\n.info-button-secondary {\n  border-radius: 6px;\n  background-color: transparent;\n  border: 1px solid #3880ff;\n  color: #3880ff;\n  padding: 0.6em 1.2em;\n  width: 180px;\n  transition: all ease 0.2s;\n  cursor: pointer;\n  margin-top: 1em;\n}\n\n.info-button-secondary:hover {\n  background-color: #e8f0ff;\n}\n\n.downloadLink {\n  text-decoration: none;\n  color: gray;\n  font-size: smaller;\n  padding: 0.5rem;\n}\n\nbutton#qr-code-icon {\n  background-color: transparent;\n  border: none;\n  min-width: 2.5rem;\n  align-self: self-end;\n  position: absolute;\n  top: 0.3rem;\n  right: 0.3rem;\n}\n\n@media only screen and (max-width: 300px) {\n  button#qr-code-icon {\n    min-width: 1.5rem;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .info-title {\n    font-size: 0.9em;\n    line-height: 1em;\n  }\n\n  .info-description {\n    font-size: 0.65em;\n  }\n\n  .qr-more-info {\n    font-size: 0.75em;\n  }\n\n  .info-wrapper {\n    max-height: 180px;\n    padding: 1.2em;\n    position: relative;\n  }\n\n  .info-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 1.8em;\n  }\n\n  .info-button {\n    padding: 0.5em 1.6em;\n    font-size: 1em;\n    font-weight: bold;\n  }\n}\n";

var _tmpl$$5 = /*#__PURE__*/template(`<div><h3 class=info-title></h3><div class=info-buttons>`),
  _tmpl$2$5 = /*#__PURE__*/template(`<div>`),
  _tmpl$3$5 = /*#__PURE__*/template(`<div class=info-description>`),
  _tmpl$4$4 = /*#__PURE__*/template(`<pre class=info-data>`),
  _tmpl$5$3 = /*#__PURE__*/template(`<button>`),
  _tmpl$6$2 = /*#__PURE__*/template(`<a class=downloadLink>`),
  _tmpl$7$1 = /*#__PURE__*/template(`<button id=qr-code-icon>`);
const Info = props => {
  return (() => {
    var _el$ = _tmpl$$5(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling;
    insert(_el$, (() => {
      var _c$ = memo(() => !!props.icon);
      return () => _c$() && (() => {
        var _el$4 = _tmpl$2$5();
        insert(_el$4, () => props.icon);
        effect(_p$ => {
          var _v$ = `info-icon ${props.iconBadge ? 'info-badge' : ''}`,
            _v$2 = props.bigIcon ? {
              'font-size': '3.4em'
            } : {};
          _v$ !== _p$.e && className(_el$4, _p$.e = _v$);
          _p$.t = style(_el$4, _v$2, _p$.t);
          return _p$;
        }, {
          e: undefined,
          t: undefined
        });
        return _el$4;
      })();
    })(), _el$2);
    insert(_el$2, () => props.title);
    insert(_el$, (() => {
      var _c$2 = memo(() => !!props.description);
      return () => _c$2() && (() => {
        var _el$5 = _tmpl$3$5();
        insert(_el$5, () => props.description);
        return _el$5;
      })();
    })(), _el$3);
    insert(_el$, (() => {
      var _c$3 = memo(() => !!props.data);
      return () => _c$3() && (() => {
        var _el$6 = _tmpl$4$4();
        insert(_el$6, () => props.data);
        return _el$6;
      })();
    })(), _el$3);
    insert(_el$3, createComponent(For, {
      get each() {
        return props.buttons;
      },
      children: button => (() => {
        var _el$7 = _tmpl$5$3();
        addEventListener(_el$7, "click", button.onClick, true);
        insert(_el$7, () => button.label);
        effect(() => className(_el$7, button.type !== 'secondary' ? 'info-button' : 'info-button-secondary'));
        return _el$7;
      })()
    }));
    insert(_el$, (() => {
      var _c$4 = memo(() => !!props.downloadLink);
      return () => _c$4() && (() => {
        var _el$8 = _tmpl$6$2();
        insert(_el$8, () => props.downloadLink.label);
        effect(() => setAttribute(_el$8, "href", props.downloadLink.url));
        return _el$8;
      })();
    })(), null);
    insert(_el$, (() => {
      var _c$5 = memo(() => !!props.onShowQRCodeClick);
      return () => _c$5() && (() => {
        var _el$9 = _tmpl$7$1();
        _el$9.$$click = () => props.onShowQRCodeClick && props.onShowQRCodeClick();
        insert(_el$9, createComponent(QRCodeIcon, {}));
        return _el$9;
      })();
    })(), null);
    effect(() => className(_el$, `info-wrapper ${props.border ? 'info-border' : ''}`));
    return _el$;
  })();
};
delegateEvents(["click"]);

const getTzip10Link = (url, payload) => `${url}?type=tzip10&data=${payload}`;

const logger$2 = new Logger('QR');
/**
 * Convert data to a QR code
 *
 * @param payload The data to be encoded as a QR code
 * @param type How the QR code will be encoded
 */
const getQrData = (payload, height, width) => {
  if (payload.length > 500) {
    logger$2.warn('getQrData', 'The size of the payload in the QR code is quite long and some devices might not be able to scan it anymore. To reduce the QR size, try using a shorter "name", "appUrl" and "iconUrl"');
  }
  try {
    const qrcode = new QRCode({
      color: 'black',
      content: payload,
      join: true,
      ecl: 'L',
      height: height,
      width: width
    });
    return qrcode.svg();
  } catch (qrError) {
    console.error('error', qrError);
    throw qrError;
  }
};

var styles$4 = ".qr-wrapper {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0.5em;\n  border: 1px solid #aaaaaa42;\n  border-radius: 10px;\n  padding: 30px;\n  height: 200px;\n}\n\n.qr-left {\n  display: flex;\n  flex-direction: column;\n  max-width: 16em;\n  height: 100%;\n}\n\n.qr-left h3 {\n  color: #334155;\n  margin: 0px;\n  margin-bottom: 0.4em;\n  font-size: 1em;\n}\n\n.theme__dark .qr-left h3 {\n  color: white;\n}\n\n.theme__dark .qr-left span {\n  color: #aeaeae;\n}\n\n.theme__dark .qr-copy-wrapper p {\n  color: #aeaeae;\n}\n\n.qr-left span {\n  font-size: 0.8em;\n  font-weight: 300;\n  color: #7c828b;\n  line-height: 1.35em;\n  margin: 0px;\n}\n\n.qr-more-info {\n  font-size: 0.95em !important;\n  text-decoration: underline;\n  margin-left: 6px !important;\n  cursor: pointer;\n}\n\n.qr-right {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  border-radius: 6px;\n  transition: all ease 0.2s;\n  cursor: pointer;\n}\n\n.theme__dark .qr-right:hover {\n  background-color: rgba(238, 238, 238, 0.492);\n}\n\n.qr-right:hover {\n  background-color: rgb(238, 238, 238);\n}\n\n.qr-copy-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.6em;\n  color: #7c828b;\n  margin-bottom: 8px;\n  margin-top: 18px;\n}\n\n.qr-copy-wrapper svg {\n  font-size: 1em;\n}\n\n.qr-copy-wrapper p {\n  font-size: 0.8em;\n  margin: 0px;\n}\n\n.qr-svg-wrapper {\n  background-color: white;\n  border-radius: 10px;\n}\n\n.qr-svg-wrapper svg rect {\n  fill: transparent !important;\n}\n\n@media only screen and (max-width: 800px) {\n  .qr-wrapper {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 340px;\n  }\n\n  .qr-left {\n    margin: 0.6em 0px;\n  }\n\n  .qr-left h3 {\n    font-size: 1em;\n    line-height: 1em;\n  }\n\n  .qr-left p {\n    font-size: 0.75em;\n    text-align: center;\n  }\n\n  .qr-left > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .qr-more-info {\n    font-size: 0.75em;\n  }\n}\n";

var _tmpl$$4 = /*#__PURE__*/template(`<div class=qr-wrapper><div class=qr-left></div><div class=qr-right>`),
  _tmpl$2$4 = /*#__PURE__*/template(`<h3>Or scan to connect`),
  _tmpl$3$4 = /*#__PURE__*/template(`<span>`),
  _tmpl$4$3 = /*#__PURE__*/template(`<span class=qr-more-info>Learn more`),
  _tmpl$5$2 = /*#__PURE__*/template(`<div class=qr-copy-wrapper><svg fill=currentColor stroke-width=0 xmlns=http://www.w3.org/2000/svg viewBox="0 0 512 512"height=1em width=1em style=overflow:visible;><path d="M243.8 339.8c-10.9 10.9-28.7 10.9-39.6 0l-64-64c-10.9-10.9-10.9-28.7 0-39.6 10.9-10.9 28.7-10.9 39.6 0l44.2 44.2 108.2-108.2c10.9-10.9 28.7-10.9 39.6 0 10.9 10.9 10.9 28.7 0 39.6l-128 128zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0s256 114.6 256 256zM256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"></path></svg><p>Copied!`),
  _tmpl$6$1 = /*#__PURE__*/template(`<div class=qr-copy-wrapper><svg fill=currentColor stroke-width=0 xmlns=http://www.w3.org/2000/svg viewBox="0 0 512 512"height=1em width=1em style=overflow:visible;><path d="M502.6 70.63 441.35 9.38C435.4 3.371 427.2 0 418.7 0H255.1c-35.35 0-64 28.66-64 64l.02 256c.88 35.4 29.58 64 64.88 64h192c35.2 0 64-28.8 64-64V93.25c0-8.48-3.4-16.62-9.4-22.62zM464 320c0 8.836-7.164 16-16 16H255.1c-8.838 0-16-7.164-16-16V64.13c0-8.836 7.164-16 16-16h128L384 96c0 17.67 14.33 32 32 32h47.1v192zM272 448c0 8.836-7.164 16-16 16H63.1c-8.838 0-16-7.164-16-16l.88-255.9c0-8.836 7.164-16 16-16H160V128H63.99c-35.35 0-64 28.65-64 64L0 448c.002 35.3 28.66 64 64 64h192c35.2 0 64-28.8 64-64v-32h-47.1l-.9 32z"></path></svg><p>Copy to clipboard`);
const COPY_RESET_TIMEOUT = 3000;
const QR = props => {
  const [copied, setCopied] = createSignal(false);
  const div = document.createElement('div');
  div.classList.add('qr-svg-wrapper');
  createEffect(() => {
    // TODO: We shouldn't do this here, that should be handled on a higher level
    const payload = props.code.startsWith('wc:') ? props.code : getTzip10Link('mavryk://', props.code);
    const qrSVG = props.isMobile ? getQrData(payload, 300, 300) : getQrData(payload, 160, 160);
    div.innerHTML = qrSVG;
  });
  async function handleCopyClipboard() {
    if (props.onClickQrCode) {
      props.onClickQrCode();
    }
    navigator.clipboard.writeText(props.code).then(() => {
      if (!copied()) {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, COPY_RESET_TIMEOUT);
      }
    }).catch(error => {
      console.error('Error copying text: ', error);
    });
  }
  return (() => {
    var _el$ = _tmpl$$4(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling;
    insert(_el$2, (() => {
      var _c$ = memo(() => !!!props.isMobile);
      return () => _c$() && _tmpl$2$4();
    })(), null);
    insert(_el$2, (() => {
      var _c$2 = memo(() => !!!props.isMobile);
      return () => _c$2() && (() => {
        var _el$5 = _tmpl$3$4();
        insert(_el$5, () => `Open ${props.walletName} Wallet on your mobile phone and scan.`);
        return _el$5;
      })();
    })(), null);
    insert(_el$2, (() => {
      var _c$3 = memo(() => !!props.isMobile);
      return () => _c$3() && (() => {
        var _el$6 = _tmpl$3$4();
        insert(_el$6, () => `Scan QR code with a ${props.isWalletConnect ? 'WalletConnect' : 'Beacon'}-compatible wallet.`, null);
        insert(_el$6, (() => {
          var _c$7 = memo(() => !!props.onClickLearnMore);
          return () => _c$7() && (() => {
            var _el$7 = _tmpl$4$3();
            _el$7.$$click = () => {
              if (props.onClickLearnMore) props.onClickLearnMore();
            };
            return _el$7;
          })();
        })(), null);
        return _el$6;
      })();
    })(), null);
    insert(_el$2, (() => {
      var _c$4 = memo(() => !!(!props.isMobile && props.onClickLearnMore));
      return () => _c$4() && (() => {
        var _el$8 = _tmpl$4$3();
        _el$8.$$click = () => {
          if (props.onClickLearnMore) props.onClickLearnMore();
        };
        _el$8.style.setProperty("margin-top", "auto");
        return _el$8;
      })();
    })(), null);
    _el$3.$$click = handleCopyClipboard;
    insert(_el$3, div, null);
    insert(_el$3, (() => {
      var _c$5 = memo(() => !!copied());
      return () => _c$5() && _tmpl$5$2();
    })(), null);
    insert(_el$3, (() => {
      var _c$6 = memo(() => !!!copied());
      return () => _c$6() && _tmpl$6$1();
    })(), null);
    effect(_p$ => {
      var _v$ = props.isMobile ? {
          'flex-direction': 'column',
          'align-items': 'center',
          'justify-content': 'center',
          height: '340px',
          'text-align': 'center',
          border: 'none'
        } : {},
        _v$2 = props.isMobile ? {
          'background-color': 'transparent'
        } : {};
      _p$.e = style(_el$, _v$, _p$.e);
      _p$.t = style(_el$3, _v$2, _p$.t);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
};
delegateEvents(["click"]);

var styles$3 = ".alert-wrapper-show {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  height: 100%;\n  width: 100vw;\n  overflow: hidden;\n  top: 0px;\n  left: 0px;\n  background-color: rgba(0, 0, 0, 0.6);\n  opacity: 1;\n  transition: all ease 0.3s;\n  z-index: 99999;\n}\n\n.alert-wrapper-hide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  height: 100%;\n  width: 100vw;\n  overflow: hidden;\n  top: 0px;\n  left: 0px;\n  background-color: rgba(0, 0, 0, 0.6);\n  opacity: 0;\n  transition: all ease 0.3s;\n  z-index: 99999;\n}\n\n.theme__dark .alert-modal-show {\n  background-color: #27334c;\n}\n\n.theme__dark .alert-modal-hide {\n  background-color: #27334c;\n}\n\n.theme__dark .alert-footer {\n  color: white;\n  -webkit-box-shadow: 0px -4px 12px rgb(0 0 0 / 20%);\n  -moz-box-shadow: 0px -4px 12px rgb(0 0 0 / 20%);\n  box-shadow: 0px -4px 12px rgb(0 0 0 / 20%);\n}\n\n.theme__dark .alert-logo svg g {\n  fill: white;\n}\n\n.alert-modal-show {\n  background-color: white;\n  border-radius: 32px;\n  transition: all ease 0.3s;\n  transform: translateY(0px);\n  opacity: 1;\n  width: 480px;\n}\n\n.alert-modal-hide {\n  background-color: white;\n  border-radius: 32px;\n  transition: all ease 0.3s;\n  transform: translateY(24px);\n  opacity: 1;\n  width: 480px;\n}\n\n.alert-modal-loading-wrapper {\n  width: 480px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.alert-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.8em;\n  padding-top: 1.2em;\n  padding-bottom: 0px;\n}\n\n.alert-button-icon-empty {\n  width: 24px;\n  height: 24px;\n  padding: 2px;\n}\n\n.alert-button-icon {\n  width: 24px;\n  height: 24px;\n  padding: 2px;\n  border-radius: 100%;\n  border: 1px solid #f0f0f1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  fill: #64748b;\n  transition: all ease 0.2s;\n}\n\n.alert-button-icon:hover {\n  background-color: #475569;\n  border: 1px solid #475569;\n  fill: #e2e8f0;\n}\n\n.alert-logo {\n  margin: 0px 6em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.alert-logo svg {\n  height: 28px;\n}\n\n.alert-body {\n  padding: 1.8em;\n  padding-bottom: 0px;\n  transition: all ease 0.3s;\n}\n\n.alert-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: grey;\n  cursor: pointer;\n  -webkit-box-shadow: 0px -4px 12px rgb(50 50 50 / 6%);\n  -moz-box-shadow: 0px -4px 12px rgb(50 50 50 / 6%);\n  box-shadow: 0px -4px 12px rgb(50 50 50 / 6%);\n  font-size: 0.938rem;\n  font-weight: bold;\n  height: 64px;\n}\n\n.alert-body-extra-show {\n  transition: all ease 0.3s;\n  overflow: hidden;\n  max-height: 35vh;\n  overflow-y: auto;\n}\n\n.alert-body-extra-hide {\n  transition: all ease 0.3s;\n  overflow: hidden;\n  max-height: 0px;\n}\n\n.alert-divider {\n  border-top: 1px solid #aaaaaa42;\n  width: 100%;\n  border-radius: 6px;\n}\n\n@media only screen and (max-width: 800px) {\n  .alert-logo {\n    margin: 0px 2em;\n  }\n\n  .alert-wrapper-show {\n    align-items: flex-end;\n    width: 100%;\n  }\n\n  .alert-wrapper-hide {\n    align-items: flex-end;\n    width: 100%;\n  }\n\n  .alert-modal-show {\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n    padding-bottom: 1.8em;\n    width: 100%;\n  }\n\n  .alert-modal-hide {\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n    padding-bottom: 1.8em;\n  }\n}\n\n@media only screen and (max-width: 300px) {\n  .alert-wrapper-show {\n    align-items: flex-end;\n    width: 100vw;\n  }\n\n  .alert-wrapper-hide {\n    align-items: flex-end;\n    width: 100vw;\n  }\n\n  .alert-body {\n    padding: 0.8em;\n  }\n\n  .alert-body {\n    padding: 0.8em;\n    padding-top: 0.4em;\n  }\n\n  .alert-logo {\n    margin: 0px;\n    transform: scale(0.8);\n  }\n}\n";

var styles$2 = ".pair-other-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #b5b8be;\n}\n";

var styles$1 = ".form-style {\n  display: flex;\n  flex-direction: column;\n  max-width: 500px;\n  min-width: 100%;\n  margin: 0 auto;\n  gap: 20px;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.label-style {\n  margin-bottom: 8px;\n}\n\n.input-style,\n.textarea-style {\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.input-style.invalid,\n.textarea-style.invalid {\n  border-color: #f76b8a;\n  border-width: medium;\n}\n\n.textarea-style {\n  height: 8rem;\n}\n\n.button-style {\n  padding: 10px 20px;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.button-style.valid {\n  background-color: #007bff;\n}\n\n.button-style.invalid {\n  background-color: #65afff;\n}\n\n.error-label {\n  display: inline;\n  font-size: 0.7rem;\n  color: #f76b8a;\n}\n\n.permissions-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.permissions-group label {\n  flex-grow: 1;\n  font-size: 0.7rem;\n}\n\n.permissions-group input {\n  flex-shrink: 0;\n}\n\n@media screen and (max-height: 700px) {\n  .textarea-style {\n    height: 6rem;\n  }\n}\n\n.button-loading::after {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  left: 0;\n  right: 0;\n  margin: auto;\n  border: 4px solid transparent;\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: button-loading-spinner 1s ease infinite;\n}\n\n@keyframes button-loading-spinner {\n  from {\n    transform: rotate(0turn);\n  }\n\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n.icon {\n  display: inline-block;\n  border: 2px solid white;\n  border-radius: 50%;\n  padding: 5px;\n  margin-bottom: 3px;\n  width: 1rem;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.success-icon {\n  animation: successAnimation 0.6s ease forwards;\n}\n\n.error-icon {\n  animation: fadeIn 0.3s ease forwards;\n}\n\n@keyframes successAnimation {\n  0% {\n    transform: rotate(0deg);\n    opacity: 0;\n  }\n  100% {\n    transform: rotate(360deg);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.thank-you-message {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.thank-you-message span {\n  opacity: 0;\n  animation: fadeInLetter 0.3s ease forwards;\n}\n\n@keyframes fadeInLetter {\n  to {\n    opacity: 1;\n  }\n}\n";

var OSLink;
(function (OSLink) {
  OSLink[OSLink["WEB"] = 0] = "WEB";
  OSLink[OSLink["IOS"] = 1] = "IOS";
  OSLink[OSLink["DESKTOP"] = 2] = "DESKTOP";
  OSLink[OSLink["EXTENSION"] = 3] = "EXTENSION";
})(OSLink || (OSLink = {}));
function parseWallets(wallets) {
  return wallets.map(wallet => {
    const tokens = ['Web', 'web', 'App', 'app', 'Mobile', 'mobile'];
    for (let i = 0; i < tokens.length; i++) {
      if (wallet.name.includes(tokens[i])) wallet.name = wallet.name.replace(tokens[i], '');
    }
    wallet.name = wallet.name.trim();
    return wallet;
  });
}
function setWallet(newWallet, wallet) {
  let choice;
  switch (wallet.type) {
    case 'web':
      choice = OSLink.WEB;
      break;
    case 'extension':
      choice = OSLink.EXTENSION;
      break;
    case 'ios':
      choice = OSLink.IOS;
      break;
    default:
      choice = OSLink.DESKTOP;
  }
  newWallet.links[choice] = wallet.type === 'ios' ? wallet.deepLink ?? wallet.link : wallet.link;
}
function arrangeTopWallets(arr, walletIds) {
  const idsToMoveToFront = walletIds.slice(0, 4);
  const itemsToMoveToFront = [];
  const itemsToSortByName = [];
  for (let item of arr) {
    let position = undefined;
    idsToMoveToFront.some((id, index) => {
      const isWallet = item.key.startsWith(id);
      if (isWallet) {
        position = index;
      }
      return isWallet;
    });
    if (typeof position !== 'undefined') {
      itemsToMoveToFront[position] = item;
    } else {
      itemsToSortByName.push(item);
    }
  }
  itemsToSortByName.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    } else {
      return 0;
    }
  });
  return [...itemsToMoveToFront, ...itemsToSortByName];
}
function mergeWallets(wallets) {
  const mergedWallets = [];
  for (let i = 0; i < wallets.length; i++) {
    const wallet = wallets[i];
    const mergedWalletsNames = mergedWallets.map(_wallet => _wallet.name);
    if (mergedWalletsNames.includes(wallet.name)) {
      const index = mergedWallets.findIndex(_wallet => _wallet.name === wallet.name);
      if (index < 0) {
        console.error('There should be a wallet');
      }
      if (!mergedWallets[index].descriptions.includes(wallet.description)) {
        setWallet(mergedWallets[index], wallet);
        mergedWallets[index].descriptions.push(wallet.description);
      }
      mergedWallets[index].types.push(wallet.type);
      mergedWallets[index].deepLink = wallet.deepLink;
      mergedWallets[index].firefoxId = wallet.key.includes('firefox') ? wallet.id : mergedWallets[index].firefoxId;
    } else {
      const newWallet = {
        ...wallet,
        descriptions: [wallet.description],
        links: ['', '', '', ''],
        types: [wallet.type],
        firefoxId: wallet.key.includes('firefox') ? wallet.id : undefined
      };
      setWallet(newWallet, wallet);
      mergedWallets.push(newWallet);
    }
  }
  return mergedWallets;
}

// Helper functions from https://github.com/ionic-team/ionic-framework/blob/master/core/src/utils/platform.ts
const testUserAgent = (win, expr) => expr.test(win.navigator.userAgent);
const matchMedia = (win, query) => win.matchMedia(query).matches;
const isMobile = win => matchMedia(win, '(any-pointer:coarse)');
// const isCordova = (win: any): boolean => Boolean(win.cordova || win.phonegap || win.PhoneGap)
// const isCapacitorNative = (win: any): boolean => {
//   const capacitor = win.Capacitor
//   return Boolean(capacitor && capacitor.isNative)
// }
// const isHybrid = (win: Window): boolean => isCordova(win) || isCapacitorNative(win)
// const isMobileWeb = (win: Window): boolean => isMobile(win) && !isHybrid(win)
const isIpad = win => {
  // iOS 12 and below
  if (testUserAgent(win, /iPad/i)) {
    return true;
  }
  // iOS 13+
  if (testUserAgent(win, /Macintosh/i) && isMobile(win)) {
    return true;
  }
  return false;
};
const isBrowser = win => testUserAgent(win, /(?:Mozilla)(?=.*\b(?:Gecko|AppleWebKit))(?=.*\b(?:Chrome|Safari|Firefox|Opera|Edge|Brave|DuckDuckGo)).*/i);
const isPrivacyBrowser = win => testUserAgent(win, /Mobile DuckDuckGo/i);
const isIOS = win => isPrivacyBrowser(win) || testUserAgent(win, /iPhone|iPod|Mobile DuckDuckGo/i) || isIpad(win);
const isAndroid = win => !isPrivacyBrowser(win) && testUserAgent(win, /android|sink/i);
const isTwBrowser = win => win && win.ethereum?.isTrust == true;
const isDesktop = win => !isMobile(win);
const isMobileOS = win => testUserAgent(win, /(Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet|Windows Phone|SymbianOS|Kindle)/i);
const currentOS = () => {
  var ua = navigator.userAgent;
  var osMap = new Map([['Windows', 'Windows'], ['Mac', 'Mac OS'], ['Linux', 'Linux'], ['iPhone', 'iOS'], ['iPad', 'iOS'], ['Android', 'Android']]);
  for (let [key, value] of osMap) {
    if (ua.indexOf(key) !== -1) {
      return value;
    }
  }
  return 'UNKOWN';
};
const currentBrowser = () => {
  var ua = navigator.userAgent;
  var browserMap = new Map([['Firefox', 'Firefox'], ['Opera', 'Opera'], ['OPR', 'Opera'], ['Trident', 'Internet Explorer'], ['Edge', 'Edge'], ['Chrome', 'Chrome'], ['Safari', 'Safari']]);
  for (let [key, value] of browserMap) {
    if (ua.indexOf(key) !== -1) {
      return value;
    }
  }
  return 'UNKOWN';
};

let colorMode = ColorMode.LIGHT;
const setColorMode = mode => {
  colorMode = mode;
};
const getColorMode = () => colorMode;

var _tmpl$$3 = /*#__PURE__*/template(`<div><span class=pair-other-info>Select QR Type</span><br>`),
  _tmpl$2$3 = /*#__PURE__*/template(`<button class=wallets-button>Beacon`),
  _tmpl$3$3 = /*#__PURE__*/template(`<button class=wallets-button>WalletConnect`);
const [uiState, setUiState] = createSignal('selection');
const [hasBeacon, setHasBeacon] = createSignal(false);
const [hasWalletConnect, setHasWalletConnect] = createSignal(false);
const [qrData, setQrData] = createSignal('');
const PairOther = props => {
  onMount(() => {
    setUiState('selection');
    setQrData('');
  });
  setHasBeacon(!!props.p2pPayload);
  setHasWalletConnect(!!props.wcPayload);
  const buttonClickHandler = state => {
    if (state === 'p2p' && !!props.p2pPayload) {
      props.p2pPayload.then(async payload => {
        const serializer = new Serializer();
        const codeQR = await serializer.serialize(payload);
        setQrData(codeQR);
      });
    } else if (state === 'walletconnect' && !!props.wcPayload) {
      props.wcPayload.then(payload => {
        setQrData(payload.uri);
      }).catch(error => console.error(error.message));
    }
    setUiState(state);
  };
  return [memo(() => memo(() => uiState() === 'selection')() && (() => {
    var _el$ = _tmpl$$3(),
      _el$2 = _el$.firstChild;
      _el$2.nextSibling;
    insert(_el$, (() => {
      var _c$ = memo(() => !!hasBeacon());
      return () => _c$() && (() => {
        var _el$4 = _tmpl$2$3();
        _el$4.$$click = () => {
          buttonClickHandler('p2p');
        };
        return _el$4;
      })();
    })(), null);
    insert(_el$, (() => {
      var _c$2 = memo(() => !!hasWalletConnect());
      return () => _c$2() && (() => {
        var _el$5 = _tmpl$3$3();
        _el$5.$$click = () => {
          buttonClickHandler('walletconnect');
        };
        return _el$5;
      })();
    })(), null);
    return _el$;
  })()), memo(() => memo(() => !!(uiState() !== 'selection' && !!qrData()))() && createComponent(QR, {
    get isWalletConnect() {
      return uiState() === 'walletconnect';
    },
    isMobile: true,
    walletName: 'AirGap',
    get code() {
      return qrData();
    },
    get onClickLearnMore() {
      return props.onClickLearnMore;
    }
  }))];
};
delegateEvents(["click"]);

function getDefaultLogo() {
  return 'data:image/svg+xml;base64,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';
}

var _tmpl$$2 = /*#__PURE__*/template(`<form class=form-style><div class=input-group><label for=title class=label-style>Title</label><input type=text id=title></div><div class=input-group><label for=description class=label-style>Description</label><textarea id=description></textarea></div><div class=input-group><label for=steps class=label-style>Steps to Reproduce</label><textarea id=steps></textarea></div><div class=permissions-group><label for=user-premissions>You agree to share anonymous data with the developers.</label><input id=user-premissions type=checkbox></div><button type=submit>`),
  _tmpl$2$2 = /*#__PURE__*/template(`<label class=error-label>`),
  _tmpl$3$2 = /*#__PURE__*/template(`<span>`),
  _tmpl$4$2 = /*#__PURE__*/template(`<div class=thank-you-message>`);
const logger$1 = new Logger('BugReport');
const BugReportForm = props => {
  const [title, setTitle] = createSignal('');
  const [titleTouched, setTitleTouched] = createSignal(false);
  const [titleErrorMsg, setTitleErrorMsg] = createSignal('');
  const [description, setDescription] = createSignal('');
  const [descriptionTouched, setDescriptionTouched] = createSignal(false);
  const [descriptionErrorMsg, setDescriptionErrorMsg] = createSignal('');
  const [steps, setSteps] = createSignal('');
  const [stepsTouched, setStepsTouched] = createSignal(false);
  const [stepsErrorMsg, setStepsErrorMsg] = createSignal('');
  const [isFormValid, setFormValid] = createSignal(false);
  const [isLoading, setIsLoading] = createSignal(false);
  const [didUserAllow, setDidUserAllow] = createSignal(false);
  const [status, setStatus] = createSignal(null);
  const [showThankYou, setShowThankYou] = createSignal(false);
  const db = new IndexedDBStorage('beacon', 'bug_report');
  const isTitleValid = () => {
    const check = title().replace(/ /gi, '').length > 10;
    const invalidText = check ? '' : 'The title must be at least 10 characters long.';
    setTitleErrorMsg(invalidText);
    return check;
  };
  const isDescriptionValid = () => {
    const check = description().replace(/ /gi, '').length >= 30;
    const invalidText = check ? '' : 'The description must be at least 30 characters long.';
    setDescriptionErrorMsg(invalidText);
    return check;
  };
  const areStepsValid = () => {
    const check = steps().replace(/ /gi, '').length >= 30;
    const invalidText = check ? '' : 'Write at least 30 characters to describe the steps to reproduce.';
    setStepsErrorMsg(invalidText);
    return check;
  };
  const indexDBToMetadata = async () => {
    const wcResult = {};
    const beaconResult = {};
    let keys = [];
    let values = [];
    try {
      keys = (await db.getAllKeys()).map(key => key.toString());
      values = await db.getAll();
    } catch (error) {
      logger$1.error('indexDBToMetadata', 'getAll failed: ', error.message);
      return [beaconResult, wcResult];
    }
    if (keys.length && values.length && keys.length === values.length) {
      keys.forEach((key, i) => (key.includes('beacon') ? beaconResult : wcResult)[key] = values[i]);
    }
    return [beaconResult, wcResult];
  };
  const getUserId = () => {
    if (!localStorage) {
      return 'UNKOWN';
    }
    const key = Object.keys(localStorage).find(key => key.includes('user-id'));
    return key && key.length ? localStorage.getItem(key) ?? 'UNKOWN' : 'UNKOWN';
  };
  createEffect(() => {
    const titleValid = isTitleValid(),
      descriptionValid = isDescriptionValid(),
      stepsValid = areStepsValid(),
      userAllow = didUserAllow();
    setFormValid(titleValid && descriptionValid && stepsValid && userAllow);
  });
  const handleSubmit = async event => {
    event.preventDefault();
    setStatus(null);
    setShowThankYou(false);
    setIsLoading(true);
    const [beaconState, wcState] = await indexDBToMetadata();
    const request = {
      userId: beaconState[StorageKey.USER_ID] && beaconState[StorageKey.USER_ID].length ? beaconState[StorageKey.USER_ID] : getUserId(),
      title: title(),
      sdkVersion: SDK_VERSION,
      description: description(),
      steps: steps(),
      os: currentOS(),
      browser: currentBrowser(),
      localStorage: JSON.stringify(beaconState),
      wcStorage: JSON.stringify(wcState)
    };
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    };
    fetch('https://beacon-backend.prod.gke.papers.tech/bug-report/save', options).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setStatus('success');
      setTimeout(() => setShowThankYou(true), 600);
      return response.json();
    }).then(data => {
      console.log(data);
    }).catch(error => {
      console.error('Error while sending report:', error.message);
      setStatus('error');
    }).then(() => {
      setIsLoading(false);
      setTimeout(() => {
        props.onSubmit();
      }, 5000);
    });
  };
  return (() => {
    var _el$ = _tmpl$$2(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$2.nextSibling,
      _el$6 = _el$5.firstChild,
      _el$7 = _el$6.nextSibling,
      _el$8 = _el$5.nextSibling,
      _el$9 = _el$8.firstChild,
      _el$10 = _el$9.nextSibling,
      _el$11 = _el$8.nextSibling,
      _el$12 = _el$11.firstChild,
      _el$13 = _el$12.nextSibling,
      _el$14 = _el$11.nextSibling;
    _el$.addEventListener("submit", handleSubmit);
    _el$4.addEventListener("blur", e => {
      !titleTouched() && setTitleTouched(true);
      setTitle(e.currentTarget.value);
    });
    insert(_el$2, (() => {
      var _c$ = memo(() => !!(titleTouched() && titleErrorMsg().length));
      return () => _c$() && (() => {
        var _el$15 = _tmpl$2$2();
        insert(_el$15, titleErrorMsg);
        return _el$15;
      })();
    })(), null);
    _el$7.addEventListener("blur", e => {
      !descriptionTouched() && setDescriptionTouched(true);
      setDescription(e.currentTarget.value);
    });
    insert(_el$5, (() => {
      var _c$2 = memo(() => !!(descriptionTouched() && descriptionErrorMsg().length));
      return () => _c$2() && (() => {
        var _el$16 = _tmpl$2$2();
        insert(_el$16, descriptionErrorMsg);
        return _el$16;
      })();
    })(), null);
    _el$10.addEventListener("blur", e => {
      !stepsTouched() && setStepsTouched(true);
      setSteps(e.currentTarget.value);
    });
    insert(_el$8, (() => {
      var _c$3 = memo(() => !!(stepsTouched() && stepsErrorMsg().length));
      return () => _c$3() && (() => {
        var _el$17 = _tmpl$2$2();
        insert(_el$17, stepsErrorMsg);
        return _el$17;
      })();
    })(), null);
    _el$13.addEventListener("change", () => setDidUserAllow(prev => !prev));
    insert(_el$14, (() => {
      var _c$4 = memo(() => !!(!isLoading() && !status()));
      return () => _c$4() ? 'Submit' : "\xA0";
    })(), null);
    insert(_el$14, (() => {
      var _c$5 = memo(() => !!(!isLoading() && status()));
      return () => _c$5() && (() => {
        var _el$18 = _tmpl$3$2();
        insert(_el$18, () => status() === 'success' ? '✓' : '✕');
        effect(() => className(_el$18, status() === 'success' ? 'icon success-icon' : 'icon error-icon'));
        return _el$18;
      })();
    })(), null);
    insert(_el$14, (() => {
      var _c$6 = memo(() => !!showThankYou());
      return () => _c$6() && (() => {
        var _el$19 = _tmpl$4$2();
        insert(_el$19, createComponent(For, {
          get each() {
            return 'Thank You!'.split('');
          },
          children: (letter, index) => (() => {
            var _el$20 = _tmpl$3$2();
            insert(_el$20, letter);
            effect(() => `${index() * 0.1}s` != null ? _el$20.style.setProperty("animation-delay", `${index() * 0.1}s`) : _el$20.style.removeProperty("animation-delay"));
            return _el$20;
          })()
        }));
        return _el$19;
      })();
    })(), null);
    effect(_p$ => {
      var _v$ = `input-style ${titleTouched() && titleErrorMsg().length ? 'invalid' : ''}`,
        _v$2 = `textarea-style ${descriptionTouched() && descriptionErrorMsg().length ? 'invalid' : ''}`,
        _v$3 = `textarea-style ${stepsTouched() && stepsErrorMsg().length ? 'invalid' : ''}`,
        _v$4 = !isFormValid(),
        _v$5 = `button-style ${isFormValid() ? 'valid' : 'invalid'} ${isLoading() ? 'button-loading' : ''}`;
      _v$ !== _p$.e && className(_el$4, _p$.e = _v$);
      _v$2 !== _p$.t && className(_el$7, _p$.t = _v$2);
      _v$3 !== _p$.a && className(_el$10, _p$.a = _v$3);
      _v$4 !== _p$.o && (_el$14.disabled = _p$.o = _v$4);
      _v$5 !== _p$.i && className(_el$14, _p$.i = _v$5);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined
    });
    effect(() => _el$4.value = title());
    effect(() => _el$7.value = description());
    effect(() => _el$10.value = steps());
    return _el$;
  })();
};

var _tmpl$$1 = /*#__PURE__*/template(`<div>`),
  _tmpl$2$1 = /*#__PURE__*/template(`<div><div></div><div></div><div>`),
  _tmpl$3$1 = /*#__PURE__*/template(`<svg fill=currentColor stroke-width=0 xmlns=http://www.w3.org/2000/svg viewBox="0 0 24 24"height=1em width=1em style=overflow:visible; color=white><path d="M16 12h2v4h-2z"></path><path d="M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM5 5h13v2H5a1.001 1.001 0 0 1 0-2zm15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15v10z">`),
  _tmpl$4$1 = /*#__PURE__*/template(`<svg fill=none stroke-width=2 xmlns=http://www.w3.org/2000/svg stroke=currentColor stroke-linecap=round stroke-linejoin=round viewBox="0 0 24 24"height=1em width=1em style=overflow:visible; color=white><path stroke=none d="M0 0h24v24H0z"></path><rect width=16 height=16 x=4 y=4 rx=2></rect><path d="M9 12h6M12 9v6">`),
  _tmpl$5$1 = /*#__PURE__*/template(`<svg fill=currentColor stroke-width=0 xmlns=http://www.w3.org/2000/svg viewBox="0 0 512 512"height=1em width=1em style=overflow:visible; color=#494949><path d="M85.57 446.25h340.86a32 32 0 0 0 28.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0 0 28.17 47.17Z"fill=none stroke=currentColor stroke-linecap=round stroke-linejoin=round stroke-width=32px></path><path d="m250.26 195.39 5.74 122 5.73-121.95a5.74 5.74 0 0 0-5.79-6h0a5.74 5.74 0 0 0-5.68 5.95Z"fill=none stroke=currentColor stroke-linecap=round stroke-linejoin=round stroke-width=32px></path><path d="M256 397.25a20 20 0 1 1 20-20 20 20 0 0 1-20 20Z">`);
const logger = new Logger('Alert');
// State variables
const [isOpen$1, setIsOpen$1] = createSignal(false);
const [isLoading, setIsLoading] = createSignal(false);
const [showMoreContent, setShowMoreContent] = createSignal(false);
const [codeQR, setCodeQR] = createSignal('');
const [walletList, setWalletList] = createSignal([]);
const [currentWallet, setCurrentWallet] = createSignal(undefined);
const [previousInfo, setPreviousInfo] = createSignal('top-wallets');
const [currentInfo, setCurrentInfo] = createSignal('top-wallets');
const [analytics, setAnalytics] = createSignal(undefined);
const [displayQrExtra, setDisplayQrExtra] = createSignal(false);
const [pairingExpired, setPairingExpired] = createSignal(false);
let dispose$1 = null;
/**
 * Close an alert by ID
 *
 * @param id ID of alert
 */
const closeAlert = _ => {
  return new Promise(async resolve => {
    if (isServer) {
      console.log('DO NOT RUN ON SERVER');
      resolve();
    }
    if (dispose$1 && isOpen$1()) {
      setIsOpen$1(false);
      setTimeout(() => {
        if (dispose$1) dispose$1();
        if (document.getElementById('beacon-alert-wrapper')) document.getElementById('beacon-alert-wrapper').remove();
      }, 500);
    }
    resolve();
  });
};
/**
 * Close all alerts
 */
const closeAlerts = async () => {
  if (currentInfo() === 'help') {
    console.log('setting status as pairing expired.');
    setPairingExpired(true);
    return;
  }
  return new Promise(async resolve => {
    if (isServer) {
      console.log('DO NOT RUN ON SERVER');
      resolve();
    }
    if (dispose$1 && isOpen$1()) {
      setIsOpen$1(false);
      setTimeout(() => {
        if (dispose$1) dispose$1();
        if (document.getElementById('beacon-alert-wrapper')) document.getElementById('beacon-alert-wrapper').remove();
      }, 500);
    }
    resolve();
  });
};
/**
 * Show an alert
 *
 * @param alertConfig The configuration of the alert
 */
// eslint-disable-next-line complexity
const openAlert = async config => {
  setIsLoading(false);
  const p2pPayload = config.pairingPayload?.p2pSyncCode();
  const wcPayload = config.pairingPayload?.walletConnectSyncCode();
  const isOnline = navigator.onLine;
  const areMetricsEnabled = localStorage ? localStorage.getItem(StorageKey.ENABLE_METRICS) === 'true' : false;
  setAnalytics(config.analytics);
  if (isServer) {
    console.log('DO NOT RUN ON SERVER');
    return '';
  }
  if (!isOpen$1()) {
    let availableExtensions = await PostMessageTransport.getAvailableExtensions();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extensionsUpdatedFn = async event => {
      if (event.data === 'extensionsUpdated') {
        availableExtensions = await PostMessageTransport.getAvailableExtensions();
        setWalletList(createWalletList());
      }
    };
    windowRef.addEventListener('message', extensionsUpdatedFn);
    const setDefaultPayload = async () => {
      if (config.pairingPayload) {
        const serializer = new Serializer();
        try {
          const codeQR = await serializer.serialize(await p2pPayload);
          setCodeQR(codeQR);
        } catch (error) {
          console.error('Cannot connect to network: ', error.message);
        }
      }
    };
    setCurrentInfo('top-wallets');
    setCurrentWallet(undefined);
    !config.title.toLowerCase().includes('error') && localStorage.removeItem(StorageKey.LAST_SELECTED_WALLET);
    // Shadow root
    const shadowRootEl = document.createElement('div');
    if (document.getElementById('beacon-alert-wrapper')) {
      document.getElementById('beacon-alert-wrapper').remove();
    }
    shadowRootEl.setAttribute('id', 'beacon-alert-wrapper');
    shadowRootEl.style.height = '0px';
    const shadowRoot = shadowRootEl.attachShadow({
      mode: 'open'
    });
    // Alert styles
    const style$1 = document.createElement('style');
    style$1.textContent = styles$3;
    shadowRoot.appendChild(style$1);
    // Top Wallets styles
    const style2 = document.createElement('style');
    style2.textContent = styles$7;
    shadowRoot.appendChild(style2);
    // Wallets styles
    const style3 = document.createElement('style');
    style3.textContent = styles$6;
    shadowRoot.appendChild(style3);
    // Wallet styles
    const style4 = document.createElement('style');
    style4.textContent = styles$8;
    shadowRoot.appendChild(style4);
    // Info styles
    const style5 = document.createElement('style');
    style5.textContent = styles$5;
    shadowRoot.appendChild(style5);
    // QR styles
    const style6 = document.createElement('style');
    style6.textContent = styles$4;
    shadowRoot.appendChild(style6);
    // Loader styles
    const style7 = document.createElement('style');
    style7.textContent = styles$9;
    shadowRoot.appendChild(style7);
    // PairOther styles
    const style8 = document.createElement('style');
    style8.textContent = styles$2;
    shadowRoot.appendChild(style8);
    // Bug report styles
    const style9 = document.createElement('style');
    style8.textContent = styles$1;
    shadowRoot.appendChild(style9);
    // Inject font styles
    const styleFonts = document.createElement('style');
    styleFonts.textContent = "* { font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', sans-serif;}";
    shadowRoot.appendChild(styleFonts);
    const createWalletList = () => {
      const wallets = [...desktopList
      // This is used for a special case where desktop wallets have inApp browsers.
      // In this case, the wallet will act like an extension. This means we have to remove
      // the desktop app from the list to make the user experience better. One example of this
      // is Infinity Wallet.
      .filter(wallet => !availableExtensions.some(extWallet => wallet.name === extWallet.name)).map(wallet => {
        return {
          id: wallet.key,
          key: wallet.key,
          name: wallet.shortName,
          image: wallet.logo,
          description: 'Desktop App',
          supportedInteractionStandards: wallet.supportedInteractionStandards,
          type: 'desktop',
          link: wallet.downloadLink,
          deepLink: wallet.deepLink
        };
      }), ...extensionList.map(wallet => {
        return {
          id: wallet.id,
          key: wallet.key,
          name: wallet.shortName,
          image: wallet.logo,
          description: 'Browser Extension',
          supportedInteractionStandards: wallet.supportedInteractionStandards,
          type: 'extension',
          link: wallet.link
        };
      }), ...iOSList.map(wallet => {
        return {
          id: wallet.key,
          key: wallet.key,
          name: wallet.shortName,
          image: wallet.logo,
          description: 'Mobile App',
          supportedInteractionStandards: wallet.supportedInteractionStandards,
          type: 'ios',
          link: wallet.universalLink,
          deepLink: wallet.deepLink
        };
      }), ...webList.map(wallet => {
        const link = wallet.links[config.pairingPayload?.networkType ?? NetworkType.MAINNET];
        return {
          id: wallet.key,
          key: wallet.key,
          name: wallet.shortName,
          image: wallet.logo,
          description: 'Web App',
          supportedInteractionStandards: wallet.supportedInteractionStandards,
          type: 'web',
          link: link ?? wallet.links.mainnet
        };
      }), ...availableExtensions.filter(newExt => !extensionList.some(ext => ext.id === newExt.id)).map(wallet => {
        return {
          id: wallet.id,
          key: wallet.id,
          name: wallet.shortName ?? wallet.name ?? '',
          image: wallet.iconUrl ?? '',
          description: 'Browser Extension',
          type: 'extension',
          link: wallet.link ?? ''
        };
      })];
      // Parse wallet names
      const parsedWallets = parseWallets(wallets);
      // Merge wallets by name
      const mergedWallets = mergeWallets(parsedWallets);
      // Default selection of featured wallets
      const defaultWalletList = ['mavryk'];
      // Sort wallets by top4
      const arrangedWallets = arrangeTopWallets(mergedWallets, config.featuredWallets ?? defaultWalletList);
      return arrangedWallets;
    };
    setWalletList(createWalletList());
    const _isMobileOS = isMobileOS(window);
    const [isMobile, setIsMobile] = createSignal(_isMobileOS);
    const [windowWidth, setWindowWidth] = createSignal(window.innerWidth);
    const AlertResize = () => {
      const debounce = (fun, delay) => {
        let timerId;
        return (...args) => {
          clearTimeout(timerId);
          timerId = setTimeout(() => fun(...args), delay);
        };
      };
      const debouncedSetWindowWidth = debounce(setWindowWidth, 200);
      const updateIsMobile = isMobileWidth => {
        // to avoid unwanted side effects (because of the OR condition), I always reset the value without checking the previous state
        setWalletList(createWalletList());
        setIsMobile(isMobileWidth || _isMobileOS);
      };
      createEffect(() => {
        updateIsMobile(windowWidth() <= 800);
      });
      // Update the windowWidth signal when the window resizes
      createEffect(() => {
        const handleResize = () => {
          debouncedSetWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        // Unsubscribe from the event when the component unmounts
        onCleanup(() => {
          window.removeEventListener('resize', handleResize);
        });
      });
      return [];
    };
    const setInstallState = wallet => {
      if (!wallet || wallet.types.length <= 1 && !wallet.types.includes('ios') && !wallet.types.includes('desktop') || _isMobileOS && wallet.types.length === 1 && wallet.types.includes('desktop')) {
        return;
      }
      setCurrentInfo('install');
    };
    const handleClickShowMoreContent = () => {
      analytics()?.track('click', 'ui', 'show more wallets');
      setShowMoreContent(!showMoreContent());
    };
    const handleClickLearnMore = () => {
      analytics()?.track('click', 'ui', 'learn more');
      setPreviousInfo(currentInfo());
      setCurrentInfo('help');
      setShowMoreContent(false);
    };
    const handleClickQrCode = () => {
      analytics()?.track('click', 'ui', 'copy QR code to clipboard');
    };
    const handleCloseAlert = () => {
      closeAlert();
      windowRef.removeEventListener('message', extensionsUpdatedFn);
      if (config.closeButtonCallback) config.closeButtonCallback();
    };
    const updateSelectedWalletWithURL = url => {
      let wallet = JSON.parse(localStorage.getItem(StorageKey.LAST_SELECTED_WALLET) ?? '{}');
      if (!wallet.key) {
        return;
      }
      wallet = {
        ...wallet,
        url
      };
      localStorage.setItem(StorageKey.LAST_SELECTED_WALLET, JSON.stringify(wallet));
    };
    const generateLink = async () => {
      let uri = (await wcPayload)?.uri ?? '';
      // If the initial URI is invalid, try generating a new one
      if (!parseUri(uri).symKey) {
        uri = (await config.pairingPayload?.walletConnectSyncCode())?.uri ?? '';
        if (!parseUri(uri).symKey) {
          handleCloseAlert();
          setTimeout(() => openAlert({
            title: 'Error',
            body: 'Unexpected transport error. Please try again.'
          }), 500);
          return null;
        }
      }
      return uri;
    };
    const handleNewTab = async (config, wallet) => {
      if (!wallet) {
        return;
      }
      if (!config.pairingPayload) {
        return;
      }
      setIsLoading(true);
      // Noopener feature parameter cannot be used, because Chrome will open
      // about:blank#blocked instead and it will no longer work.
      const newTab = window.open('', '_blank');
      if (newTab) {
        newTab.opener = null;
      }
      let link = '';
      if (wallet.supportedInteractionStandards?.includes('wallet_connect') && !wallet.name.toLowerCase().includes('kukai')) {
        const uri = await generateLink();
        if (!uri) {
          return;
        }
        link = `${wallet.links[OSLink.WEB]}/wc?uri=${encodeURIComponent(uri)}`;
      } else {
        const serializer = new Serializer();
        const code = await serializer.serialize(await p2pPayload);
        link = getTzip10Link(wallet.links[OSLink.WEB], code);
      }
      if (newTab) {
        newTab.location.href = link;
      } else {
        window.open(link, '_blank', 'noopener');
      }
      localStorage.setItem(StorageKey.LAST_SELECTED_WALLET, JSON.stringify({
        key: wallet.key,
        name: wallet.name,
        type: 'web',
        icon: currentWallet()?.image
      }));
    };
    const handleDeepLinking = async (wallet, uri) => {
      localStorage.setItem(StorageKey.LAST_SELECTED_WALLET, JSON.stringify({
        key: wallet.key,
        type: 'mobile',
        icon: wallet.image
      }));
      if (!wallet.links[OSLink.IOS].length) {
        const syncCode = currentWallet()?.supportedInteractionStandards?.includes('wallet_connect') ? (await wcPayload)?.uri ?? '' : await new Serializer().serialize(await p2pPayload);
        if (!syncCode.length) {
          handleCloseAlert();
          return;
        }
        setCodeQR(syncCode);
        setCurrentInfo('qr');
        setDisplayQrExtra(true);
        return;
      }
      const link = `${wallet.links[OSLink.IOS]}wc?uri=${encodeURIComponent(uri)}`;
      updateSelectedWalletWithURL(`${wallet.links[OSLink.IOS]}wc?uri=`);
      logger.log('DO DEEPLINK WITH ' + link);
      if (isTwBrowser(window) && isAndroid(window)) {
        window.location.href = `${uri}`;
      }
      if (isAndroid(window)) {
        window.open(link, '_blank', 'noopener');
      } else {
        const a = document.createElement('a');
        a.setAttribute('href', link);
        a.setAttribute('rel', 'noopener');
        a.dispatchEvent(new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        }));
      }
    };
    const handleClickWallet = async id => {
      setIsLoading(true);
      setShowMoreContent(false);
      const wallet = walletList().find(wallet => wallet.id === id);
      setCurrentWallet(wallet);
      if (wallet?.key) {
        analytics()?.track('click', 'ui', 'opened wallet', {
          key: wallet.key
        });
      }
      localStorage.setItem(StorageKey.LAST_SELECTED_WALLET, JSON.stringify({
        key: wallet?.key,
        type: 'mobile',
        icon: currentWallet()?.image
      }));
      if (wallet?.types.includes('web') && wallet?.types.length === 1 || isAndroid(window) && wallet?.name.toLowerCase().includes('kukai')) {
        handleNewTab(config, wallet);
        return;
      }
      if (wallet && wallet.supportedInteractionStandards?.includes('wallet_connect')) {
        const uri = await generateLink();
        if (uri) {
          if (_isMobileOS && wallet.types.includes('ios') && wallet.types.length === 1) {
            handleDeepLinking(wallet, uri);
          } else {
            setCodeQR(uri);
            setInstallState(wallet);
          }
        }
        setIsLoading(false);
      } else if (wallet?.types.includes('ios') && _isMobileOS) {
        setCodeQR('');
        if (config.pairingPayload) {
          const serializer = new Serializer();
          const code = await serializer.serialize(await p2pPayload);
          const link = getTzip10Link(isIOS(window) && wallet.deepLink ? wallet.deepLink : isAndroid(window) ? wallet.links[OSLink.IOS] : 'mavryk://', code);
          updateSelectedWalletWithURL(link);
          if (isAndroid(window)) window.open(link, '_blank', 'noopener');else if (isIOS(window)) {
            const a = document.createElement('a');
            a.setAttribute('href', link);
            a.setAttribute('rel', 'noopener');
            a.dispatchEvent(new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            }));
          }
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setInstallState(wallet);
        await setDefaultPayload();
      }
    };
    const handleClickOther = async () => {
      analytics()?.track('click', 'ui', 'other wallet');
      localStorage.setItem(StorageKey.LAST_SELECTED_WALLET, JSON.stringify({
        key: 'wallet',
        name: 'wallet',
        type: 'mobile',
        icon: getDefaultLogo()
      }));
      setCurrentInfo('qr');
    };
    const handleClickConnectExtension = async () => {
      analytics()?.track('click', 'ui', 'open extension', {
        key: currentWallet()?.key
      });
      setShowMoreContent(false);
      if (config.pairingPayload?.postmessageSyncCode) {
        const serializer = new Serializer();
        const postmessageCode = await serializer.serialize(await config.pairingPayload.postmessageSyncCode());
        const message = {
          target: ExtensionMessageTarget.EXTENSION,
          payload: postmessageCode,
          targetId: currentWallet()?.id
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        windowRef.postMessage(message, windowRef.location.origin);
        if (currentWallet()?.firefoxId) {
          const message = {
            target: ExtensionMessageTarget.EXTENSION,
            payload: postmessageCode,
            targetId: currentWallet()?.firefoxId
          };
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          windowRef.postMessage(message, windowRef.location.origin);
        }
      }
      localStorage.setItem(StorageKey.LAST_SELECTED_WALLET, JSON.stringify({
        key: currentWallet()?.key,
        name: currentWallet()?.name,
        type: 'extension',
        icon: currentWallet()?.image
      }));
    };
    const handleClickInstallExtension = async () => {
      analytics()?.track('click', 'ui', 'install extension', {
        key: currentWallet()?.key
      });
      setShowMoreContent(false);
      window.open(currentWallet()?.links[OSLink.EXTENSION] || '', '_blank', 'noopener');
    };
    const handleClickOpenDesktopApp = async () => {
      setShowMoreContent(false);
      analytics()?.track('click', 'ui', 'open desktop', {
        key: currentWallet()?.key
      });
      if (await p2pPayload) {
        const serializer = new Serializer();
        const code = await serializer.serialize(await p2pPayload);
        const link = getTzip10Link(currentWallet()?.deepLink || '', code);
        window.open(link, '_blank', 'noopener');
      }
      localStorage.setItem(StorageKey.LAST_SELECTED_WALLET, JSON.stringify({
        key: currentWallet()?.key,
        name: currentWallet()?.name,
        type: 'desktop',
        icon: currentWallet()?.image
      }));
    };
    const handleClickDownloadDesktopApp = async () => {
      analytics()?.track('click', 'ui', 'download desktop', {
        key: currentWallet()?.key
      });
      setShowMoreContent(false);
      window.open(currentWallet()?.links[OSLink.DESKTOP] || '', '_blank', 'noopener');
    };
    const hasExtension = () => availableExtensions.map(extension => extension.id).includes(currentWallet()?.firefoxId || '') || availableExtensions.map(extension => extension.id).includes(currentWallet()?.id || '');
    const QRCode = ({
      isMobile
    }) => {
      localStorage.setItem(StorageKey.LAST_SELECTED_WALLET, JSON.stringify({
        key: currentWallet()?.key,
        name: currentWallet()?.name,
        type: 'mobile',
        icon: currentWallet()?.image
      }));
      return createComponent(QR, {
        get isWalletConnect() {
          return currentWallet()?.supportedInteractionStandards?.includes('wallet_connect') || false;
        },
        isMobile: isMobile,
        get walletName() {
          return currentWallet()?.name || 'AirGap';
        },
        get code() {
          return codeQR();
        },
        onClickLearnMore: handleClickLearnMore,
        onClickQrCode: handleClickQrCode
      });
    };
    const colorMode = getColorMode();
    dispose$1 = render(() => (() => {
      var _el$ = _tmpl$$1();
      className(_el$, `theme__${colorMode}`);
      insert(_el$, createComponent(AlertResize, {}), null);
      insert(_el$, (() => {
        var _c$ = memo(() => !!config.pairingPayload);
        return () => _c$() && createComponent(Alert, {
          get loading() {
            return isLoading();
          },
          get open() {
            return isOpen$1();
          },
          get showMore() {
            return showMoreContent();
          },
          get content() {
            return (() => {
              var _el$2 = _tmpl$2$1(),
                _el$3 = _el$2.firstChild,
                _el$4 = _el$3.nextSibling,
                _el$5 = _el$4.nextSibling;
              insert(_el$2, (() => {
                var _c$3 = memo(() => currentInfo() === 'install');
                return () => _c$3() && (() => {
                  var _el$6 = _tmpl$$1();
                  insert(_el$6, (() => {
                    var _c$5 = memo(() => !!(isOnline && currentWallet()?.types.includes('web')));
                    return () => _c$5() && createComponent(Info, {
                      border: true,
                      get title() {
                        return `Connect with ${currentWallet()?.name} Web`;
                      },
                      description: `(It will open the wallet in a new tab)`,
                      buttons: [{
                        label: 'Use Browser',
                        type: 'primary',
                        onClick: () => handleNewTab(config, currentWallet())
                      }]
                    });
                  })(), null);
                  insert(_el$6, (() => {
                    var _c$6 = memo(() => !!(!isMobile() && currentWallet()?.types.includes('extension')));
                    return () => _c$6() && createComponent(Info, {
                      border: true,
                      get title() {
                        return memo(() => !!hasExtension())() ? `Connect with ${currentWallet()?.name} Browser Extension` : `Install ${currentWallet()?.name} Wallet`;
                      },
                      get description() {
                        return memo(() => !!hasExtension())() ? `Please connect below to use your ${currentWallet()?.name} Wallet browser extension.` : `To connect your ${currentWallet()?.name} Wallet, install the browser extension.`;
                      },
                      get buttons() {
                        return hasExtension() ? [{
                          label: 'Use Extension',
                          type: 'primary',
                          onClick: () => handleClickConnectExtension()
                        }] : [{
                          label: 'Install extension',
                          type: 'primary',
                          onClick: () => handleClickInstallExtension()
                        }];
                      }
                    });
                  })(), null);
                  insert(_el$6, (() => {
                    var _c$7 = memo(() => !!(!isMobile() && currentWallet()?.types.includes('desktop')));
                    return () => _c$7() && createComponent(Info, {
                      border: true,
                      get title() {
                        return `Connect with ${currentWallet()?.name} Desktop App`;
                      },
                      description: `If you don't have the desktop app installed, click below to download it.`,
                      buttons: [{
                        label: 'Open desktop app',
                        type: 'primary',
                        onClick: () => handleClickOpenDesktopApp()
                      }, {
                        label: 'Download desktop app',
                        type: 'secondary',
                        onClick: () => handleClickDownloadDesktopApp()
                      }]
                    });
                  })(), null);
                  insert(_el$6, (() => {
                    var _c$8 = memo(() => !!(!isMobile() && codeQR().length > 0 && currentWallet()?.types.includes('ios') && currentWallet()?.types.length > 1));
                    return () => _c$8() && createComponent(QRCode, {
                      isMobile: false
                    });
                  })(), null);
                  insert(_el$6, (() => {
                    var _c$9 = memo(() => !!(!isMobile() && codeQR().length > 0 && currentWallet()?.types.includes('ios') && currentWallet()?.types.length <= 1));
                    return () => _c$9() && createComponent(QRCode, {
                      isMobile: true
                    });
                  })(), null);
                  insert(_el$6, (() => {
                    var _c$10 = memo(() => !!(isMobile() && currentWallet()?.types.includes('ios')));
                    return () => _c$10() && createComponent(Info, {
                      border: true,
                      get title() {
                        return `Connect with ${currentWallet()?.name} Mobile`;
                      },
                      description: '',
                      buttons: [{
                        label: 'Use App',
                        type: 'primary',
                        onClick: async () => {
                          const wallet = currentWallet();
                          if (!wallet) {
                            return;
                          }
                          let syncCode = '';
                          if (wallet.supportedInteractionStandards?.includes('wallet_connect')) {
                            syncCode = (await wcPayload)?.uri ?? '';
                          } else {
                            syncCode = await new Serializer().serialize(await p2pPayload);
                          }
                          handleDeepLinking(wallet, syncCode);
                        }
                      }],
                      get downloadLink() {
                        return currentWallet()?.name.toLowerCase().includes('kukai') && isIOS(window) ? {
                          label: 'Get Kukai Mobile >',
                          url: 'https://ios.kukai.app'
                        } : undefined;
                      },
                      onShowQRCodeClick: async () => {
                        const syncCode = currentWallet()?.supportedInteractionStandards?.includes('wallet_connect') ? (await wcPayload)?.uri ?? '' : await new Serializer().serialize(await p2pPayload);
                        const wallet = currentWallet();
                        if (!syncCode.length || !wallet) {
                          handleCloseAlert();
                          return;
                        }
                        if (_isMobileOS && wallet.types.includes('ios') && wallet.types.length === 1) {
                          handleDeepLinking(wallet, syncCode);
                        } else {
                          setCodeQR(syncCode);
                        }
                        setCurrentInfo('qr');
                        setDisplayQrExtra(true);
                      }
                    });
                  })(), null);
                  effect(_$p => style(_el$6, currentInfo() === 'install' || currentInfo() === 'qr' ? {
                    opacity: 1,
                    height: 'unset',
                    overflow: 'unset',
                    transform: 'scale(1)',
                    transition: 'all ease 0.3s',
                    display: 'flex',
                    'flex-direction': 'column',
                    gap: '0.9em'
                  } : {
                    opacity: 0,
                    height: 0,
                    overflow: 'hidden',
                    transform: 'scale(1.1)',
                    transition: 'all ease 0.3s',
                    display: 'flex',
                    'flex-direction': 'column',
                    gap: '0.9em'
                  }, _$p));
                  return _el$6;
                })();
              })(), _el$3);
              insert(_el$2, (() => {
                var _c$4 = memo(() => currentInfo() === 'qr');
                return () => _c$4() && (() => {
                  var _el$7 = _tmpl$$1();
                  insert(_el$7, (() => {
                    var _c$11 = memo(() => !!!displayQrExtra());
                    return () => _c$11() ? createComponent(PairOther, {
                      get walletList() {
                        return walletList();
                      },
                      onClickLearnMore: handleClickLearnMore,
                      p2pPayload: p2pPayload,
                      wcPayload: wcPayload
                    }) : createComponent(QRCode, {
                      isMobile: true
                    });
                  })());
                  effect(_$p => style(_el$7, currentInfo() === 'install' || currentInfo() === 'qr' ? {
                    opacity: 1,
                    height: 'unset',
                    overflow: 'unset',
                    transform: 'scale(1)',
                    transition: 'all ease 0.3s',
                    display: 'flex',
                    'flex-direction': 'column',
                    gap: '0.9em'
                  } : {
                    opacity: 0,
                    height: 0,
                    overflow: 'hidden',
                    transform: 'scale(1.1)',
                    transition: 'all ease 0.3s',
                    display: 'flex',
                    'flex-direction': 'column',
                    gap: '0.9em'
                  }, _$p));
                  return _el$7;
                })();
              })(), _el$3);
              insert(_el$3, createComponent(Wallets, {
                get wallets() {
                  return walletList().slice(-(walletList().length - (isMobile() ? 3 : 4)));
                },
                get isMobile() {
                  return isMobile();
                },
                onClickWallet: handleClickWallet,
                onClickOther: handleClickOther
              }));
              insert(_el$4, areMetricsEnabled && createComponent(BugReportForm, {
                onSubmit: () => {
                  handleCloseAlert();
                }
              }), null);
              insert(_el$4, !areMetricsEnabled && [createComponent(Info, {
                iconBadge: true,
                get icon() {
                  return _tmpl$3$1();
                },
                title: "What is a wallet?",
                description: "Wallets let you send, receive, store and interact with digital assets. Your wallet can be used as an easy way to login, instead of having to remember a password."
              }), createComponent(Info, {
                iconBadge: true,
                get icon() {
                  return _tmpl$4$1();
                },
                title: "Not sure where to start?",
                description: "If you are new to the Web3, we recommend that you start by creating a Kukai wallet. Kukai is a fast way of creating your first wallet using your preferred social account."
              })], null);
              insert(_el$5, createComponent(TopWallets, {
                get wallets() {
                  return memo(() => !!isMobile())() ? walletList().slice(0, 3) : walletList().slice(0, 4);
                },
                get isMobile() {
                  return isMobile();
                },
                onClickWallet: handleClickWallet,
                onClickLearnMore: handleClickLearnMore,
                get otherWallets() {
                  return memo(() => !!isMobile())() ? {
                    images: [walletList()[3].image, walletList()[4].image, walletList()[5].image],
                    onClick: () => setCurrentInfo('wallets')
                  } : undefined;
                }
              }));
              effect(_p$ => {
                var _v$ = currentInfo() === 'wallets' ? {
                    opacity: 1,
                    height: 'unset',
                    overflow: 'unset',
                    transform: 'scale(1)',
                    transition: 'all ease 0.3s'
                  } : {
                    opacity: 0,
                    height: 0,
                    overflow: 'hidden',
                    transform: 'scale(1.1)',
                    transition: 'all ease 0.3s'
                  },
                  _v$2 = currentInfo() === 'help' ? {
                    opacity: 1,
                    height: 'unset',
                    overflow: 'unset',
                    transform: 'scale(1)',
                    transition: 'all ease 0.3s',
                    display: 'flex',
                    'flex-direction': 'column',
                    gap: '0.9em'
                  } : {
                    opacity: 0,
                    height: 0,
                    overflow: 'hidden',
                    transform: 'scale(1.1)',
                    transition: 'all ease 0.3s',
                    display: 'flex',
                    'flex-direction': 'column',
                    gap: '0.9em'
                  },
                  _v$3 = currentInfo() !== 'install' && currentInfo() !== 'qr' && currentInfo() !== 'wallets' && currentInfo() !== 'help' ? {
                    opacity: 1,
                    height: 'unset',
                    overflow: 'unset',
                    transform: 'scale(1)',
                    transition: 'all ease 0.3s'
                  } : {
                    opacity: 0,
                    height: 0,
                    overflow: 'hidden',
                    transform: 'scale(1.1)',
                    transition: 'all ease 0.3s'
                  };
                _p$.e = style(_el$3, _v$, _p$.e);
                _p$.t = style(_el$4, _v$2, _p$.t);
                _p$.a = style(_el$5, _v$3, _p$.a);
                return _p$;
              }, {
                e: undefined,
                t: undefined,
                a: undefined
              });
              return _el$2;
            })();
          },
          get extraContent() {
            return memo(() => !!(currentInfo() !== 'top-wallets' || isMobile()))() ? undefined : createComponent(Wallets, {
              small: true,
              get wallets() {
                return walletList().slice(-(walletList().length - 4));
              },
              get isMobile() {
                return isMobile();
              },
              onClickWallet: handleClickWallet,
              onClickOther: handleClickOther
            });
          },
          onClickShowMore: handleClickShowMoreContent,
          onCloseClick: () => handleCloseAlert(),
          get onBackClick() {
            return memo(() => currentInfo() === 'install')() ? () => setCurrentInfo('top-wallets') : memo(() => currentInfo() === 'qr')() ? () => setCurrentInfo('top-wallets') : memo(() => !!(currentInfo() === 'wallets' && isMobile()))() ? () => setCurrentInfo('top-wallets') : currentInfo() === 'help' ? () => {
              if (pairingExpired()) {
                handleCloseAlert();
                return;
              }
              return setCurrentInfo(previousInfo());
            } : undefined;
          }
        });
      })(), null);
      insert(_el$, (() => {
        var _c$2 = memo(() => !!!config.pairingPayload);
        return () => _c$2() && createComponent(Alert, {
          get open() {
            return isOpen$1();
          },
          get content() {
            return createComponent(Info, {
              bigIcon: true,
              get icon() {
                return _tmpl$5$1();
              },
              get title() {
                return config.title || 'No title';
              },
              get description() {
                return config.body || 'No description';
              },
              get data() {
                return config.data;
              },
              buttons: [{
                label: 'Close',
                type: 'primary',
                onClick: () => handleCloseAlert()
              }]
            });
          },
          onCloseClick: () => handleCloseAlert()
        });
      })(), null);
      return _el$;
    })(), shadowRoot);
    document.body.prepend(shadowRootEl);
    setTimeout(() => {
      setIsOpen$1(true);
    }, 50);
  }
  return '';
};

// export interface PairingProps {}
// const Pairing: Component<PairingProps> = (props: PairingProps) => {
//   return (
//     <div>
//       <h1>Pairing Component</h1>
//     </div>
//   )
// }
// export default Pairing
/**
 * Initialize with mavryk wallets for backwards compatibility
 */
let localDesktopList = desktopList;
let localExtensionList = extensionList;
let localWebList = webList;
let localiOSList = iOSList;
const getDesktopList = () => {
  return localDesktopList;
};
const setDesktopList = desktopList => {
  localDesktopList = desktopList;
};
const getExtensionList = () => {
  return localExtensionList;
};
const setExtensionList = extensionList => {
  localExtensionList = extensionList;
};
const getWebList = () => {
  return localWebList;
};
const setWebList = webList => {
  localWebList = webList;
};
const getiOSList = () => {
  return localiOSList;
};
const setiOSList = iosList => {
  localiOSList = iosList;
};
var Platform;
(function (Platform) {
  Platform[Platform["DESKTOP"] = 0] = "DESKTOP";
  Platform[Platform["IOS"] = 1] = "IOS";
  Platform[Platform["ANDROID"] = 2] = "ANDROID";
})(Platform || (Platform = {}));
var WalletType;
(function (WalletType) {
  WalletType["IOS"] = "ios";
  WalletType["ANDROID"] = "android";
  WalletType["EXTENSION"] = "extension";
  WalletType["DESKTOP"] = "desktop";
  WalletType["WEB"] = "web";
})(WalletType || (WalletType = {}));
/**
 * @internalapi
 *
 */
class Pairing {}

var _tmpl$ = /*#__PURE__*/template(`<img>`),
  _tmpl$2 = /*#__PURE__*/template(`<h3>`),
  _tmpl$3 = /*#__PURE__*/template(`<p class=toast-label>`),
  _tmpl$4 = /*#__PURE__*/template(`<div><div class=toast-header><div class=toast-button-icon>`),
  _tmpl$5 = /*#__PURE__*/template(`<p class=toast-label>props.label`),
  _tmpl$6 = /*#__PURE__*/template(`<div class=toast-action-button>Open Wallet`),
  _tmpl$7 = /*#__PURE__*/template(`<div class=toast-body>`),
  _tmpl$8 = /*#__PURE__*/template(`<div class=toast-action-wrapper><p>`),
  _tmpl$9 = /*#__PURE__*/template(`<div class=toast-action-button>`);
function parseWallet(inputString, walletInfo) {
  const regex = /({{\s*wallet\s*}})/g;
  const parts = inputString.split(regex);
  return parts.map(part => {
    if (part.match(regex)) {
      return [(() => {
        var _el$ = _tmpl$();
        effect(() => setAttribute(_el$, "src", walletInfo.icon));
        return _el$;
      })(), (() => {
        var _el$2 = _tmpl$2();
        insert(_el$2, () => walletInfo.name);
        return _el$2;
      })()];
    } else {
      return (() => {
        var _el$3 = _tmpl$3();
        insert(_el$3, part);
        return _el$3;
      })();
    }
  });
}
const [showMoreInfo, setShowMoreInfo] = createSignal(true);
const Toast = props => {
  const hasWalletObject = props.label.includes('{{wallet}}') && props.walletInfo;
  const isRequestSentToast = props.label.includes('Request sent to');
  const offset = {
    x: isMobileOS(window) ? 12 : window.innerWidth - 460,
    y: 12
  };
  const [divPosition, setDivPosition] = createSignal(offset);
  const [isDragging, setIsDragging] = createSignal(false);
  const onMouseDownHandler = event => {
    event.preventDefault(); // prevents inner text highlighting
    const target = event.target;
    if (target.className !== 'toast-header' && target.parentElement?.className !== 'toast-header') {
      return;
    }
    const boundinRect = target.getBoundingClientRect();
    offset.x = event.clientX - boundinRect.x;
    offset.y = event.clientY - boundinRect.y;
    setIsDragging(true);
  };
  const onMouseMoveHandler = event => {
    if (isDragging() && event.buttons === 1) {
      const newX = Math.min(Math.max(event.clientX - offset.x, 0), window.innerWidth - 460);
      const newY = Math.min(Math.max(event.clientY - offset.y, 0), window.innerHeight - 12);
      setDivPosition({
        x: newX,
        y: newY
      });
    }
  };
  const onMouseUpHandler = () => {
    setIsDragging(false);
  };
  const onClickHandler = () => {
    setIsDragging(false);
  };
  // when the mouse is out of the div boundaries but it is still pressed, keep moving the toast
  createEffect(() => {
    if (isDragging()) {
      window.addEventListener('mousemove', onMouseMoveHandler);
      window.addEventListener('mouseup', onMouseUpHandler);
    } else {
      window.removeEventListener('mousemove', onMouseMoveHandler);
      window.removeEventListener('mouseup', onMouseUpHandler);
    }
  });
  if (isRequestSentToast) {
    setShowMoreInfo(false);
    setTimeout(() => {
      setShowMoreInfo(true);
    }, 3000);
  }
  return (() => {
    var _el$4 = _tmpl$4(),
      _el$5 = _el$4.firstChild,
      _el$6 = _el$5.firstChild;
    _el$4.$$dblclick = onClickHandler;
    _el$4.$$click = onClickHandler;
    _el$4.$$mousedown = onMouseDownHandler;
    insert(_el$5, createComponent(Loader, {}), _el$6);
    insert(_el$5, (() => {
      var _c$ = memo(() => !!(hasWalletObject && props.walletInfo));
      return () => _c$() && memo(() => parseWallet(props.label, props.walletInfo));
    })(), _el$6);
    insert(_el$5, !hasWalletObject && _tmpl$5(), _el$6);
    insert(_el$5, (() => {
      var _c$2 = memo(() => !!(!isMobileOS(window) && props.openWalletAction));
      return () => _c$2() && (() => {
        var _el$8 = _tmpl$6();
        _el$8.$$click = () => {
          if (props && props.openWalletAction) {
            props?.openWalletAction();
          }
        };
        return _el$8;
      })();
    })(), _el$6);
    addEventListener(_el$6, "click", props.onClickClose, true);
    insert(_el$6, createComponent(CloseIcon, {}));
    insert(_el$4, (() => {
      var _c$3 = memo(() => !!(props.actions && showMoreInfo()));
      return () => _c$3() && (() => {
        var _el$9 = _tmpl$7();
        insert(_el$9, createComponent(For, {
          get each() {
            return props.actions;
          },
          children: action => (() => {
            var _el$10 = _tmpl$8(),
              _el$11 = _el$10.firstChild;
            insert(_el$11, () => action.text);
            insert(_el$10, (() => {
              var _c$4 = memo(() => !!action.actionText);
              return () => _c$4() && (() => {
                var _el$12 = _tmpl$9();
                _el$12.$$click = () => {
                  if (action.actionCallback) action.actionCallback();
                };
                insert(_el$12, () => action.actionText);
                return _el$12;
              })();
            })(), null);
            effect(() => className(_el$11, `toast-action-label ${action.isBold ? 'toast-action-bold' : ''}`));
            return _el$10;
          })()
        }));
        return _el$9;
      })();
    })(), null);
    effect(_p$ => {
      var _v$ = `${divPosition().x}px`,
        _v$2 = `${divPosition().y}px`,
        _v$3 = props.open ? 'toast-wrapper-show' : 'toast-wrapper-hide';
      _v$ !== _p$.e && ((_p$.e = _v$) != null ? _el$4.style.setProperty("left", _v$) : _el$4.style.removeProperty("left"));
      _v$2 !== _p$.t && ((_p$.t = _v$2) != null ? _el$4.style.setProperty("top", _v$2) : _el$4.style.removeProperty("top"));
      _v$3 !== _p$.a && className(_el$4, _p$.a = _v$3);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    return _el$4;
  })();
};
delegateEvents(["mousedown", "click", "dblclick"]);

var styles = ".toast-wrapper-show {\n  max-width: 460px;\n  overflow: hidden;\n  background-color: white;\n  position: fixed;\n  top: 12px;\n  right: 12px;\n  border-radius: 6px;\n  transition: all ease 0.3s;\n  transform: translateY(0px) scale(1);\n  z-index: 1000000;\n  -webkit-box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.45);\n  -moz-box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.45);\n  box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.45);\n}\n\n.toast-wrapper-hide {\n  max-width: 460px;\n  overflow: hidden;\n  background-color: white;\n  position: fixed;\n  top: 12px;\n  right: 12px;\n  border-radius: 6px;\n  transition: all ease 0.3s;\n  transform: translateY(-150px) scale(0.2);\n  z-index: 1000000;\n  -webkit-box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.45);\n  -moz-box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.45);\n  box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.45);\n}\n\n.toast-header {\n  cursor: move;\n  padding: 0px 0.6em 0px 1.2em;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  overflow: hidden;\n  position: relative;\n}\n\n.toast-header img {\n  width: 24px;\n}\n\n.toast-header h3 {\n  font-weight: bold;\n  color: #334155;\n  font-size: 0.8em;\n  margin-right: auto;\n}\n\n.toast-label {\n  margin: 1em 0em 1em 0em;\n  color: #334155;\n  font-size: 0.9em;\n}\n\n.toast-button-icon {\n  width: 24px;\n  height: 24px;\n  padding: 2px;\n  border-radius: 100%;\n  border: 1px solid #cbd5e1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  fill: #64748b;\n  transition: all ease 0.2s;\n  margin-left: auto;\n}\n\n.toast-button-icon:hover {\n  background-color: #475569;\n  border: 1px solid #475569;\n  fill: #e2e8f0;\n}\n\n.toast-body {\n  padding: 0.6em 1.2em;\n}\n\n.toast-action-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.toast-action-label {\n  margin: 0.8em 0em;\n  font-size: 0.8em;\n  color: #64748b;\n}\n\n.toast-action-bold {\n  font-weight: bold;\n  color: #334155;\n}\n\n.toast-action-button {\n  cursor: pointer;\n  font-size: 0.8em;\n  font-weight: 600;\n  color: #3880ff;\n  transition: all ease 0.2s;\n  border-radius: 6px;\n  padding: 0.4em 0.8em;\n}\n\n.toast-action-button:hover {\n  background-color: #e4eeff;\n  transition: all ease 0.2s;\n}\n\n@media only screen and (max-width: 800px) {\n  .toast-wrapper-show {\n    width: calc(100% - 24px);\n  }\n\n  .toast-wrapper-hide {\n    width: calc(100% - 24px);\n  }\n}\n";

let dispose = null;
const [isOpen, setIsOpen] = createSignal(false);
const [renderLast, setRenderLast] = createSignal('');
const ANIMATION_TIME = 300;
let globalTimeout;
const createToast = config => {
  const shadowRootEl = document.createElement('div');
  if (document.getElementById('beacon-toast-wrapper')) {
    document.getElementById('beacon-toast-wrapper').remove();
  }
  shadowRootEl.setAttribute('id', 'beacon-toast-wrapper');
  shadowRootEl.style.height = '0px';
  const shadowRoot = shadowRootEl.attachShadow({
    mode: 'open'
  });
  // Toast styles
  const style = document.createElement('style');
  style.textContent = styles;
  shadowRoot.appendChild(style);
  // Loader styles
  const style2 = document.createElement('style');
  style2.textContent = styles$9;
  shadowRoot.appendChild(style2);
  // Inject font styles
  const styleFonts = document.createElement('style');
  styleFonts.textContent = "* { font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', sans-serif;}";
  shadowRoot.appendChild(styleFonts);
  dispose = render(() => createComponent(Toast, {
    get label() {
      return config.body;
    },
    get open() {
      return isOpen();
    },
    onClickClose: () => {
      closeToast();
    },
    get actions() {
      return config.actions;
    },
    get walletInfo() {
      return config.walletInfo;
    },
    get openWalletAction() {
      return config.openWalletAction;
    }
  }), shadowRoot);
  // Create toast
  document.body.prepend(shadowRootEl);
  // Open toast
  setTimeout(() => {
    setIsOpen(true);
  }, 50);
  // Add close timer if in config
  clearTimeout(globalTimeout);
  if (config.timer) {
    globalTimeout = setTimeout(() => closeToast(), config.timer);
  }
};
/**
 * Close a toast
 */
const closeToast = () => new Promise(resolve => {
  if (isServer) {
    console.log('DO NOT RUN ON SERVER');
    resolve();
  }
  setIsOpen(false);
  setTimeout(() => {
    if (dispose) dispose();
    if (document.getElementById('beacon-toast-wrapper')) document.getElementById('beacon-toast-wrapper').remove();
    resolve();
  }, ANIMATION_TIME);
});
/**
 * Create a new toast
 *
 * @param toastConfig Configuration of the toast
 */
const openToast = async config => {
  if (isServer) {
    console.log('DO NOT RUN ON SERVER');
    return;
  }
  const id = await generateGUID();
  setRenderLast(id);
  await closeToast();
  if (id === renderLast()) createToast(config);
};

export { Pairing, closeAlerts, closeToast, currentBrowser, currentOS, getColorMode, getDesktopList, getExtensionList, getWebList, getiOSList, isAndroid, isBrowser, isDesktop, isIOS, isMobile, isMobileOS, openAlert, openToast, setColorMode, setDesktopList, setExtensionList, setWebList, setiOSList };
